// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/automations/v1/automations.proto" (package "c1.api.automations.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { ConflictMonitorRef } from "../../accessconflict/v1/accessconflict";
import { Form } from "../../form/v1/form";
import { AppUserType } from "../../app/v1/app_user";
import { ConnectorRef } from "../../app/v1/connector";
import { Struct } from "../../../../google/protobuf/struct";
import { UserStatus } from "../../user/v1/user";
import { AppEntitlementRef } from "../../app/v1/app_refs";
import { Duration } from "../../../../google/protobuf/duration";
import { UserRef } from "../../user/v1/user";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { FieldMask } from "../../../../google/protobuf/field_mask";
/**
 * @generated from protobuf message c1.api.automations.v1.SearchAutomationsRequest
 */
export interface SearchAutomationsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationTemplateRef refs = 4
     */
    refs: AutomationTemplateRef[];
    /**
     * @generated from protobuf field: string app_id = 5
     */
    appId: string;
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.TriggerType trigger_types = 6
     */
    triggerTypes: TriggerType[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.SearchAutomationsResponse
 */
export interface SearchAutomationsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.Automation list = 1
     */
    list: Automation[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.SearchAutomationTemplateVersionsRequest
 */
export interface SearchAutomationTemplateVersionsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string automation_template_id = 3
     */
    automationTemplateId: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.SearchAutomationTemplateVersionsResponse
 */
export interface SearchAutomationTemplateVersionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationTemplateVersion list = 1
     */
    list: AutomationTemplateVersion[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GetAutomationRequest
 */
export interface GetAutomationRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GetAutomationResponse
 */
export interface GetAutomationResponse {
    /**
     * @generated from protobuf field: c1.api.automations.v1.Automation automation = 1
     */
    automation?: Automation;
}
/**
 * @generated from protobuf message c1.api.automations.v1.CreateAutomationRequest
 */
export interface CreateAutomationRequest {
    /**
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * @generated from protobuf field: bool enabled = 3
     */
    enabled: boolean;
    /**
     * @deprecated
     * @generated from protobuf field: c1.api.automations.v1.AutomationContext context = 4 [deprecated = true]
     */
    context?: AutomationContext;
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationStep automation_steps = 5
     */
    automationSteps: AutomationStep[];
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationTrigger triggers = 6
     */
    triggers: AutomationTrigger[];
    /**
     * the app id this workflow_template belongs to
     *
     * @generated from protobuf field: string app_id = 7
     */
    appId: string;
    /**
     * @generated from protobuf field: bool is_draft = 8
     */
    isDraft: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationStep draft_automation_steps = 9
     */
    draftAutomationSteps: AutomationStep[];
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationTrigger draft_triggers = 10
     */
    draftTriggers: AutomationTrigger[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.CreateAutomationResponse
 */
export interface CreateAutomationResponse {
    /**
     * @generated from protobuf field: c1.api.automations.v1.Automation automation = 1
     */
    automation?: Automation;
    /**
     * If we create a new trigger with an HMAC secret we return the HMAC on this field
     *
     * @generated from protobuf field: string webhook_hmac_secret = 2
     */
    webhookHmacSecret: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.ExecuteAutomationRequest
 */
export interface ExecuteAutomationRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationContext context = 2
     */
    context?: AutomationContext;
}
/**
 * @generated from protobuf message c1.api.automations.v1.ExecuteAutomationResponse
 */
export interface ExecuteAutomationResponse {
    /**
     * @generated from protobuf field: int64 execution_id = 1
     */
    executionId: number;
}
/**
 * @generated from protobuf message c1.api.automations.v1.UpdateAutomationRequest
 */
export interface UpdateAutomationRequest {
    /**
     * @generated from protobuf field: c1.api.automations.v1.Automation automation = 1
     */
    automation?: Automation;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.automations.v1.UpdateAutomationResponse
 */
export interface UpdateAutomationResponse {
    /**
     * @generated from protobuf field: c1.api.automations.v1.Automation automation = 1
     */
    automation?: Automation;
    /**
     * If we create a new trigger with an HMAC secret we return the HMAC on this field
     *
     * @generated from protobuf field: string webhook_hmac_secret = 2
     */
    webhookHmacSecret: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.DeleteAutomationRequest
 */
export interface DeleteAutomationRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.DeleteAutomationResponse
 */
export interface DeleteAutomationResponse {
}
/**
 * @generated from protobuf message c1.api.automations.v1.ListAutomationsRequest
 */
export interface ListAutomationsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.ListAutomationsResponse
 */
export interface ListAutomationsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.Automation list = 1
     */
    list: Automation[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.Automation
 */
export interface Automation {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @generated from protobuf field: bool enabled = 4
     */
    enabled: boolean;
    /**
     * @generated from protobuf oneof: disabled_reason
     */
    disabledReason: {
        oneofKind: "circuitBreaker";
        /**
         * @generated from protobuf field: c1.api.automations.v1.DisabledReasonCircuitBreaker circuit_breaker = 101
         */
        circuitBreaker: DisabledReasonCircuitBreaker;
    } | {
        oneofKind: undefined;
    };
    /**
     * @deprecated
     * @generated from protobuf field: c1.api.automations.v1.AutomationContext context = 5 [deprecated = true]
     */
    context?: AutomationContext;
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationStep automation_steps = 6
     */
    automationSteps: AutomationStep[];
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationTrigger triggers = 7
     */
    triggers: AutomationTrigger[];
    /**
     * @generated from protobuf field: c1.api.automations.v1.TriggerType primary_trigger_type = 15
     */
    primaryTriggerType: TriggerType;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_executed_at = 8
     */
    lastExecutedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 9
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationStep draft_automation_steps = 10
     */
    draftAutomationSteps: AutomationStep[];
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationTrigger draft_triggers = 11
     */
    draftTriggers: AutomationTrigger[];
    /**
     * @generated from protobuf field: bool is_draft = 12
     */
    isDraft: boolean;
    /**
     * @generated from protobuf field: int64 current_version = 13
     */
    currentVersion: number;
    /**
     * the app id this workflow_template belongs to
     *
     * @generated from protobuf field: string app_id = 14
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.DisabledReasonCircuitBreaker
 */
export interface DisabledReasonCircuitBreaker {
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationTemplateRef
 */
export interface AutomationTemplateRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationStep
 */
export interface AutomationStep {
    /**
     * @generated from protobuf field: string step_name = 1
     */
    stepName: string;
    /**
     * @generated from protobuf oneof: kind
     */
    kind: {
        oneofKind: "createAccessReview";
        /**
         * @generated from protobuf field: c1.api.automations.v1.CreateAccessReview create_access_review = 101
         */
        createAccessReview: CreateAccessReview;
    } | {
        oneofKind: "waitForDuration";
        /**
         * @generated from protobuf field: c1.api.automations.v1.WaitForDuration wait_for_duration = 102
         */
        waitForDuration: WaitForDuration;
    } | {
        oneofKind: "unenrollFromAllAccessProfiles";
        /**
         * @generated from protobuf field: c1.api.automations.v1.UnenrollFromAllAccessProfiles unenroll_from_all_access_profiles = 103
         */
        unenrollFromAllAccessProfiles: UnenrollFromAllAccessProfiles;
    } | {
        oneofKind: "createRevokeTasks";
        /**
         * @deprecated
         * @generated from protobuf field: c1.api.automations.v1.CreateRevokeTasks create_revoke_tasks = 104 [deprecated = true]
         */
        createRevokeTasks: CreateRevokeTasks;
    } | {
        oneofKind: "createRevokeTasksV2";
        /**
         * @generated from protobuf field: c1.api.automations.v1.CreateRevokeTasksV2 create_revoke_tasks_v2 = 117
         */
        createRevokeTasksV2: CreateRevokeTasksV2;
    } | {
        oneofKind: "sendEmail";
        /**
         * @generated from protobuf field: c1.api.automations.v1.SendEmail send_email = 105
         */
        sendEmail: SendEmail;
    } | {
        oneofKind: "removeFromDelegation";
        /**
         * @generated from protobuf field: c1.api.automations.v1.RemoveFromDelegation remove_from_delegation = 106
         */
        removeFromDelegation: RemoveFromDelegation;
    } | {
        oneofKind: "runAutomation";
        /**
         * @generated from protobuf field: c1.api.automations.v1.RunAutomation run_automation = 107
         */
        runAutomation: RunAutomation;
    } | {
        oneofKind: "updateUser";
        /**
         * @generated from protobuf field: c1.api.automations.v1.UpdateUser update_user = 108
         */
        updateUser: UpdateUser;
    } | {
        oneofKind: "taskAction";
        /**
         * @generated from protobuf field: c1.api.automations.v1.TaskAction task_action = 109
         */
        taskAction: TaskAction;
    } | {
        oneofKind: "webhook";
        /**
         * @generated from protobuf field: c1.api.automations.v1.Webhook webhook = 110
         */
        webhook: Webhook;
    } | {
        oneofKind: "connectorAction";
        /**
         * @generated from protobuf field: c1.api.automations.v1.ConnectorAction connector_action = 111
         */
        connectorAction: ConnectorAction;
    } | {
        oneofKind: "connectorCreateAccount";
        /**
         * @generated from protobuf field: c1.api.automations.v1.ConnectorCreateAccount connector_create_account = 112
         */
        connectorCreateAccount: ConnectorCreateAccount;
    } | {
        oneofKind: "grantEntitlements";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantEntitlements grant_entitlements = 113
         */
        grantEntitlements: GrantEntitlements;
    } | {
        oneofKind: "sendSlackMessage";
        /**
         * @generated from protobuf field: c1.api.automations.v1.SendSlackMessage send_slack_message = 114
         */
        sendSlackMessage: SendSlackMessage;
    } | {
        oneofKind: "callFunction";
        /**
         * @generated from protobuf field: c1.api.automations.v1.CallFunction call_function = 115
         */
        callFunction: CallFunction;
    } | {
        oneofKind: "accountLifecycleAction";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AccountLifecycleAction account_lifecycle_action = 116
         */
        accountLifecycleAction: AccountLifecycleAction;
    } | {
        oneofKind: "generatePassword";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GeneratePassword generate_password = 120
         */
        generatePassword: GeneratePassword;
    } | {
        oneofKind: "evaluateExpressions";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EvaluateExpressions evaluate_expressions = 121
         */
        evaluateExpressions: EvaluateExpressions;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string skip_if_true_cel = 2
     */
    skipIfTrueCel: string;
    /**
     * @generated from protobuf field: string step_display_name = 3
     */
    stepDisplayName: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.SendEmail
 */
export interface SendEmail {
    /**
     * @generated from protobuf field: string subject = 1
     */
    subject: string;
    /**
     * @generated from protobuf field: string body = 2
     */
    body: string;
    /**
     * @generated from protobuf field: string title = 3
     */
    title: string;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserRef user_refs = 4
     */
    userRefs: UserRef[];
    /**
     * @generated from protobuf field: string user_ids_cel = 5
     */
    userIdsCel: string;
    /**
     * If true, the step will use the subject user of the automation as the subject.
     *
     * @generated from protobuf field: bool use_subject_user = 6
     */
    useSubjectUser: boolean;
}
/**
 * @generated from protobuf message c1.api.automations.v1.SendSlackMessage
 */
export interface SendSlackMessage {
    /**
     * @generated from protobuf field: string body = 1
     */
    body: string;
    /**
     * @generated from protobuf oneof: channel
     */
    channel: {
        oneofKind: "channelName";
        /**
         * @generated from protobuf field: string channel_name = 2
         */
        channelName: string;
    } | {
        oneofKind: "channelNameCel";
        /**
         * @generated from protobuf field: string channel_name_cel = 3
         */
        channelNameCel: string;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.CallFunction
 */
export interface CallFunction {
    /**
     * @generated from protobuf field: string function_id = 1
     */
    functionId: string;
    /**
     * @generated from protobuf field: map<string, string> args = 2
     */
    args: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.CreateAccessReview
 */
export interface CreateAccessReview {
    /**
     * @generated from protobuf field: string access_review_template_id = 1
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: string access_review_template_cel = 2
     */
    accessReviewTemplateCel: string;
    /**
     * @generated from protobuf field: string user_ids_cel = 3
     */
    userIdsCel: string;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserRef user_refs = 4
     */
    userRefs: UserRef[];
    /**
     * If true, the step will use the subject user of the automation as the subject.
     *
     * @generated from protobuf field: bool use_subject_user = 5
     */
    useSubjectUser: boolean;
    /**
     * Optional campaign name. If not provided, the campaign name will be the access review template name.
     *
     * @generated from protobuf field: string campaign_name = 6
     */
    campaignName: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.WaitForDuration
 */
export interface WaitForDuration {
    /**
     * @generated from protobuf field: google.protobuf.Duration duration = 1
     */
    duration?: Duration;
}
/**
 * @generated from protobuf message c1.api.automations.v1.UnenrollFromAllAccessProfiles
 */
export interface UnenrollFromAllAccessProfiles {
    /**
     * @generated from protobuf field: string user_ids_cel = 1
     */
    userIdsCel: string;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserRef user_refs = 2
     */
    userRefs: UserRef[];
    /**
     * Optional list of catalog IDs to unenroll from. If empty, unenroll from all catalogs.
     *
     * @generated from protobuf field: repeated string catalog_ids = 3
     */
    catalogIds: string[];
    /**
     * CEL expression to dynamically select catalog IDs. If provided, overrides catalog_ids.
     *
     * @generated from protobuf field: string catalog_ids_cel = 5
     */
    catalogIdsCel: string;
    /**
     * If true, the step will use the subject user of the automation as the subject.
     *
     * @generated from protobuf field: bool use_subject_user = 4
     */
    useSubjectUser: boolean;
}
/**
 * @generated from protobuf message c1.api.automations.v1.CreateRevokeTasks
 */
export interface CreateRevokeTasks {
    /**
     * @generated from protobuf field: string user_id_cel = 1
     */
    userIdCel: string;
    /**
     * Required only if user_id_cel is not provided.
     *
     * @generated from protobuf field: c1.api.user.v1.UserRef user_ref = 2
     */
    userRef?: UserRef;
    /**
     * @generated from protobuf field: string app_entitlement_refs_cel = 3
     */
    appEntitlementRefsCel: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 4
     */
    appEntitlementRefs: AppEntitlementRef[];
    /**
     * @generated from protobuf field: bool revoke_all = 5
     */
    revokeAll: boolean;
    /**
     * If true, the step will use the subject user of the automation as the subject.
     *
     * @generated from protobuf field: bool use_subject_user = 6
     */
    useSubjectUser: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef excluded_app_entitlement_refs = 7
     */
    excludedAppEntitlementRefs: AppEntitlementRef[];
    /**
     * @generated from protobuf field: string excluded_app_entitlement_refs_cel = 8
     */
    excludedAppEntitlementRefsCel: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.CreateRevokeTasksV2
 */
export interface CreateRevokeTasksV2 {
    /**
     * @generated from protobuf oneof: user
     */
    user: {
        oneofKind: "userIdCel";
        /**
         * @generated from protobuf field: string user_id_cel = 1
         */
        userIdCel: string;
    } | {
        oneofKind: "userRef";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserRef user_ref = 2
         */
        userRef: UserRef;
    } | {
        oneofKind: "useSubjectUser";
        /**
         * @generated from protobuf field: bool use_subject_user = 3
         */
        useSubjectUser: boolean;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: inclusion
     */
    inclusion: {
        oneofKind: "inclusionList";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementInclusionList inclusion_list = 4
         */
        inclusionList: EntitlementInclusionList;
    } | {
        oneofKind: "inclusionAll";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementInclusionAll inclusion_all = 5
         */
        inclusionAll: EntitlementInclusionAll;
    } | {
        oneofKind: "inclusionCriteria";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementInclusionCriteria inclusion_criteria = 6
         */
        inclusionCriteria: EntitlementInclusionCriteria;
    } | {
        oneofKind: "inclusionListCel";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementInclusionListCel inclusion_list_cel = 20
         */
        inclusionListCel: EntitlementInclusionListCel;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: exclusion
     */
    exclusion: {
        oneofKind: "exclusionNone";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementExclusionNone exclusion_none = 7
         */
        exclusionNone: EntitlementExclusionNone;
    } | {
        oneofKind: "exclusionList";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementExclusionList exclusion_list = 8
         */
        exclusionList: EntitlementExclusionList;
    } | {
        oneofKind: "exclusionCriteria";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementExclusionCriteria exclusion_criteria = 9
         */
        exclusionCriteria: EntitlementExclusionCriteria;
    } | {
        oneofKind: "exclusionListCel";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementExclusionListCel exclusion_list_cel = 30
         */
        exclusionListCel: EntitlementExclusionListCel;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.EntitlementInclusionAll
 */
export interface EntitlementInclusionAll {
}
/**
 * @generated from protobuf message c1.api.automations.v1.EntitlementInclusionList
 */
export interface EntitlementInclusionList {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 1
     */
    appEntitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.EntitlementInclusionCriteria
 */
export interface EntitlementInclusionCriteria {
    /**
     * @generated from protobuf field: repeated string app_ids = 1
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 2
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string risk_level_ids = 3
     */
    riskLevelIds: string[];
    /**
     * @generated from protobuf field: repeated string compliance_framework_ids = 4
     */
    complianceFrameworkIds: string[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.EntitlementInclusionListCel
 */
export interface EntitlementInclusionListCel {
    /**
     * @generated from protobuf field: string app_entitlement_refs_cel = 1
     */
    appEntitlementRefsCel: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.EntitlementExclusionNone
 */
export interface EntitlementExclusionNone {
}
/**
 * @generated from protobuf message c1.api.automations.v1.EntitlementExclusionList
 */
export interface EntitlementExclusionList {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef excluded_app_entitlement_refs = 1
     */
    excludedAppEntitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.EntitlementExclusionCriteria
 */
export interface EntitlementExclusionCriteria {
    /**
     * @generated from protobuf field: repeated string excluded_app_ids = 1
     */
    excludedAppIds: string[];
    /**
     * @generated from protobuf field: repeated string excluded_resource_type_ids = 2
     */
    excludedResourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string excluded_risk_level_ids = 3
     */
    excludedRiskLevelIds: string[];
    /**
     * @generated from protobuf field: repeated string excluded_compliance_framework_ids = 4
     */
    excludedComplianceFrameworkIds: string[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.EntitlementExclusionListCel
 */
export interface EntitlementExclusionListCel {
    /**
     * @generated from protobuf field: string excluded_app_entitlement_refs_cel = 1
     */
    excludedAppEntitlementRefsCel: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantEntitlements
 */
export interface GrantEntitlements {
    /**
     * @generated from protobuf field: string user_id_cel = 1
     */
    userIdCel: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserRef user_ref = 2
     */
    userRef?: UserRef;
    /**
     * @generated from protobuf field: string app_entitlement_refs_cel = 3
     */
    appEntitlementRefsCel: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 4
     */
    appEntitlementRefs: AppEntitlementRef[];
    /**
     * If true, the step will use the subject user of the automation as the subject.
     *
     * @generated from protobuf field: bool use_subject_user = 5
     */
    useSubjectUser: boolean;
    /**
     * @generated from protobuf oneof: inclusion
     */
    inclusion: {
        oneofKind: "inclusionList";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantEntitlementInclusionList inclusion_list = 10
         */
        inclusionList: GrantEntitlementInclusionList;
    } | {
        oneofKind: "inclusionCriteria";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantEntitlementInclusionCriteria inclusion_criteria = 11
         */
        inclusionCriteria: GrantEntitlementInclusionCriteria;
    } | {
        oneofKind: "inclusionListCel";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantEntitlementInclusionListCel inclusion_list_cel = 12
         */
        inclusionListCel: GrantEntitlementInclusionListCel;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: exclusion
     */
    exclusion: {
        oneofKind: "exclusionNone";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantEntitlementExclusionNone exclusion_none = 20
         */
        exclusionNone: GrantEntitlementExclusionNone;
    } | {
        oneofKind: "exclusionList";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantEntitlementExclusionList exclusion_list = 21
         */
        exclusionList: GrantEntitlementExclusionList;
    } | {
        oneofKind: "exclusionCriteria";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantEntitlementExclusionCriteria exclusion_criteria = 22
         */
        exclusionCriteria: GrantEntitlementExclusionCriteria;
    } | {
        oneofKind: "exclusionListCel";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantEntitlementExclusionListCel exclusion_list_cel = 23
         */
        exclusionListCel: GrantEntitlementExclusionListCel;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantEntitlementInclusionList
 */
export interface GrantEntitlementInclusionList {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 1
     */
    appEntitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantEntitlementInclusionCriteria
 */
export interface GrantEntitlementInclusionCriteria {
    /**
     * @generated from protobuf field: repeated string app_ids = 1
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated string risk_level_ids = 2
     */
    riskLevelIds: string[];
    /**
     * @generated from protobuf field: repeated string compliance_framework_ids = 3
     */
    complianceFrameworkIds: string[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantEntitlementInclusionListCel
 */
export interface GrantEntitlementInclusionListCel {
    /**
     * @generated from protobuf field: string app_entitlement_refs_cel = 1
     */
    appEntitlementRefsCel: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantEntitlementExclusionNone
 */
export interface GrantEntitlementExclusionNone {
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantEntitlementExclusionList
 */
export interface GrantEntitlementExclusionList {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef excluded_app_entitlement_refs = 1
     */
    excludedAppEntitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantEntitlementExclusionCriteria
 */
export interface GrantEntitlementExclusionCriteria {
    /**
     * @generated from protobuf field: repeated string excluded_app_ids = 1
     */
    excludedAppIds: string[];
    /**
     * @generated from protobuf field: repeated string excluded_risk_level_ids = 2
     */
    excludedRiskLevelIds: string[];
    /**
     * @generated from protobuf field: repeated string excluded_compliance_framework_ids = 3
     */
    excludedComplianceFrameworkIds: string[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantEntitlementExclusionListCel
 */
export interface GrantEntitlementExclusionListCel {
    /**
     * @generated from protobuf field: string excluded_app_entitlement_refs_cel = 1
     */
    excludedAppEntitlementRefsCel: string;
}
/**
 * RemoveFromDelegation: find all users that have the target user as their delegated user, and modify the delegation.
 *
 * @generated from protobuf message c1.api.automations.v1.RemoveFromDelegation
 */
export interface RemoveFromDelegation {
    /**
     * @generated from protobuf field: string user_id_cel = 1
     */
    userIdCel: string;
    /**
     * Required only if user_id_cel is not provided.
     *
     * @generated from protobuf field: c1.api.user.v1.UserRef user_ref = 2
     */
    userRef?: UserRef;
    /**
     * If true, the step will use the subject user of the automation as the subject.
     *
     * @generated from protobuf field: bool use_subject_user = 3
     */
    useSubjectUser: boolean;
    /**
     * @generated from protobuf oneof: replacement_user
     */
    replacementUser: {
        oneofKind: "replacementUserIdCel";
        /**
         * The user who will replace the target user's delegation
         *
         * @generated from protobuf field: string replacement_user_id_cel = 4
         */
        replacementUserIdCel: string;
    } | {
        oneofKind: "replacementUserRef";
        /**
         * Required only if replacement_user_id_cel is not provided.
         *
         * @generated from protobuf field: c1.api.user.v1.UserRef replacement_user_ref = 5
         */
        replacementUserRef: UserRef;
    } | {
        oneofKind: undefined;
    };
}
/**
 * RunAutomation: kick off the execution of an automation template.
 *
 * @generated from protobuf message c1.api.automations.v1.RunAutomation
 */
export interface RunAutomation {
    /**
     * @generated from protobuf oneof: automation_template
     */
    automationTemplate: {
        oneofKind: "automationTemplateRef";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AutomationTemplateRef automation_template_ref = 1
         */
        automationTemplateRef: AutomationTemplateRef;
    } | {
        oneofKind: "automationTemplateIdCel";
        /**
         * @generated from protobuf field: string automation_template_id_cel = 2
         */
        automationTemplateIdCel: string;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationContext context = 3
     */
    context?: AutomationContext;
}
/**
 * @generated from protobuf message c1.api.automations.v1.UpdateUser
 */
export interface UpdateUser {
    /**
     * @generated from protobuf oneof: user
     */
    user: {
        oneofKind: "userIdCel";
        /**
         * @generated from protobuf field: string user_id_cel = 5
         */
        userIdCel: string;
    } | {
        oneofKind: "userRef";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserRef user_ref = 6
         */
        userRef: UserRef;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: user_status
     */
    userStatus: {
        oneofKind: "userStatusEnum";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserStatus user_status_enum = 7
         */
        userStatusEnum: UserStatus;
    } | {
        oneofKind: "userStatusCel";
        /**
         * @generated from protobuf field: string user_status_cel = 8
         */
        userStatusCel: string;
    } | {
        oneofKind: undefined;
    };
    /**
     * If true, the step will use the subject user of the automation as the subject.
     *
     * @generated from protobuf field: bool use_subject_user = 9
     */
    useSubjectUser: boolean;
}
/**
 * @generated from protobuf message c1.api.automations.v1.CloseAction
 */
export interface CloseAction {
    /**
     * @generated from protobuf oneof: user_identifier
     */
    userIdentifier: {
        oneofKind: "userIdCel";
        /**
         * @generated from protobuf field: string user_id_cel = 1
         */
        userIdCel: string;
    } | {
        oneofKind: "userRef";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserRef user_ref = 2
         */
        userRef: UserRef;
    } | {
        oneofKind: undefined;
    };
    /**
     * If true, the step will use the subject user of the automation as the subject.
     *
     * @generated from protobuf field: bool use_subject_user = 3
     */
    useSubjectUser: boolean;
}
/**
 * @generated from protobuf message c1.api.automations.v1.ReassignAction
 */
export interface ReassignAction {
    /**
     * @generated from protobuf oneof: assignee_user_identifier
     */
    assigneeUserIdentifier: {
        oneofKind: "assigneeUserIdCel";
        /**
         * @generated from protobuf field: string assignee_user_id_cel = 1
         */
        assigneeUserIdCel: string;
    } | {
        oneofKind: "assigneeUserRef";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserRef assignee_user_ref = 2
         */
        assigneeUserRef: UserRef;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: subject_user_identifier
     */
    subjectUserIdentifier: {
        oneofKind: "subjectUserIdCel";
        /**
         * @generated from protobuf field: string subject_user_id_cel = 3
         */
        subjectUserIdCel: string;
    } | {
        oneofKind: "subjectUserRef";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserRef subject_user_ref = 4
         */
        subjectUserRef: UserRef;
    } | {
        oneofKind: undefined;
    };
    /**
     * If true, the step will use the subject user of the automation as the subject.
     *
     * @generated from protobuf field: bool use_subject_user = 5
     */
    useSubjectUser: boolean;
}
/**
 * @generated from protobuf message c1.api.automations.v1.TaskAction
 */
export interface TaskAction {
    /**
     * @generated from protobuf oneof: action
     */
    action: {
        oneofKind: "close";
        /**
         * @generated from protobuf field: c1.api.automations.v1.CloseAction close = 1
         */
        close: CloseAction;
    } | {
        oneofKind: "reassign";
        /**
         * @generated from protobuf field: c1.api.automations.v1.ReassignAction reassign = 2
         */
        reassign: ReassignAction;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.TaskType task_types = 3
     */
    taskTypes: TaskType[];
    /**
     * @generated from protobuf field: c1.api.automations.v1.TaskUserRelation task_user_relation = 4
     */
    taskUserRelation: TaskUserRelation;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationContext
 */
export interface AutomationContext {
    /**
     * @generated from protobuf field: google.protobuf.Struct context = 1
     */
    context?: Struct;
}
/**
 * @generated from protobuf message c1.api.automations.v1.Webhook
 */
export interface Webhook {
    /**
     * @generated from protobuf oneof: webhook_identifier
     */
    webhookIdentifier: {
        oneofKind: "webhookId";
        /**
         * @generated from protobuf field: string webhook_id = 1
         */
        webhookId: string;
    } | {
        oneofKind: "webhookIdCel";
        /**
         * @generated from protobuf field: string webhook_id_cel = 2
         */
        webhookIdCel: string;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: google.protobuf.Struct payload = 3
     */
    payload?: Struct;
}
/**
 * @generated from protobuf message c1.api.automations.v1.ConnectorAction
 */
export interface ConnectorAction {
    /**
     * @generated from protobuf oneof: connector_identifier
     */
    connectorIdentifier: {
        oneofKind: "connectorRef";
        /**
         * @generated from protobuf field: c1.api.app.v1.ConnectorRef connector_ref = 1
         */
        connectorRef: ConnectorRef;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string action_name = 2
     */
    actionName: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct args_template = 3
     */
    argsTemplate?: Struct;
    /**
     * @generated from protobuf field: string resource_type_id = 4
     */
    resourceTypeId: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AccountLifecycleAction
 */
export interface AccountLifecycleAction {
    /**
     * @generated from protobuf field: c1.api.app.v1.ConnectorRef connector_ref = 1
     */
    connectorRef?: ConnectorRef;
    /**
     * @generated from protobuf field: string action_name = 2
     */
    actionName: string;
    /**
     * @generated from protobuf oneof: account_identifier
     */
    accountIdentifier: {
        oneofKind: "accountRef";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AccountRef account_ref = 100
         */
        accountRef: AccountRef;
    } | {
        oneofKind: "accountInContext";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AccountInContext account_in_context = 101
         */
        accountInContext: AccountInContext;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.GeneratePassword
 */
export interface GeneratePassword {
}
/**
 * @generated from protobuf message c1.api.automations.v1.EvaluateExpressions
 */
export interface EvaluateExpressions {
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.Expression expressions = 1
     */
    expressions: Expression[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.Expression
 */
export interface Expression {
    /**
     * @generated from protobuf field: string key = 1
     */
    key: string;
    /**
     * @generated from protobuf field: string expression_cel = 2
     */
    expressionCel: string;
    /**
     * @generated from protobuf field: bool is_secret = 3
     */
    isSecret: boolean;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AccountInContext
 */
export interface AccountInContext {
}
/**
 * @generated from protobuf message c1.api.automations.v1.AccountRef
 */
export interface AccountRef {
    /**
     * @generated from protobuf field: string account_id_cel = 1
     */
    accountIdCel: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.ConnectorCreateAccount
 */
export interface ConnectorCreateAccount {
    /**
     * @generated from protobuf field: c1.api.app.v1.ConnectorRef connector_ref = 1
     */
    connectorRef?: ConnectorRef;
    /**
     * @generated from protobuf oneof: create_account_arguments
     */
    createAccountArguments: {
        oneofKind: "userIdCel";
        /**
         * @generated from protobuf field: string user_id_cel = 2
         */
        userIdCel: string;
    } | {
        oneofKind: "userProperties";
        /**
         * @generated from protobuf field: c1.api.automations.v1.UserProperties user_properties = 3
         */
        userProperties: UserProperties;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.UserProperties
 */
export interface UserProperties {
    /**
     * @generated from protobuf field: string display_name_cel = 1
     */
    displayNameCel: string;
    /**
     * @generated from protobuf field: string email_cel = 2
     */
    emailCel: string;
    /**
     * @generated from protobuf field: string username_cel = 3
     */
    usernameCel: string;
    /**
     * @generated from protobuf field: string profile_attribute_cel = 4
     */
    profileAttributeCel: string;
}
/**
 * Automation Triggers
 *
 * @generated from protobuf message c1.api.automations.v1.AutomationTrigger
 */
export interface AutomationTrigger {
    /**
     * @generated from protobuf oneof: kind
     */
    kind: {
        oneofKind: "manual";
        /**
         * @generated from protobuf field: c1.api.automations.v1.ManualAutomationTrigger manual = 101
         */
        manual: ManualAutomationTrigger;
    } | {
        oneofKind: "userProfileChange";
        /**
         * @generated from protobuf field: c1.api.automations.v1.UserProfileChangeTrigger user_profile_change = 102
         */
        userProfileChange: UserProfileChangeTrigger;
    } | {
        oneofKind: "appUserCreated";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AppUserCreatedTrigger app_user_created = 103
         */
        appUserCreated: AppUserCreatedTrigger;
    } | {
        oneofKind: "appUserUpdated";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AppUserUpdatedTrigger app_user_updated = 104
         */
        appUserUpdated: AppUserUpdatedTrigger;
    } | {
        oneofKind: "usageBasedRevocation";
        /**
         * @generated from protobuf field: c1.api.automations.v1.UsageBasedRevocationTrigger usage_based_revocation = 105
         */
        usageBasedRevocation: UsageBasedRevocationTrigger;
    } | {
        oneofKind: "userCreated";
        /**
         * @generated from protobuf field: c1.api.automations.v1.UserCreatedTrigger user_created = 106
         */
        userCreated: UserCreatedTrigger;
    } | {
        oneofKind: "grantFound";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantFoundTrigger grant_found = 107
         */
        grantFound: GrantFoundTrigger;
    } | {
        oneofKind: "grantDeleted";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantDeletedTrigger grant_deleted = 108
         */
        grantDeleted: GrantDeletedTrigger;
    } | {
        oneofKind: "webhook";
        /**
         * @generated from protobuf field: c1.api.automations.v1.WebhookAutomationTrigger webhook = 109
         */
        webhook: WebhookAutomationTrigger;
    } | {
        oneofKind: "schedule";
        /**
         * @generated from protobuf field: c1.api.automations.v1.ScheduleTrigger schedule = 110
         */
        schedule: ScheduleTrigger;
    } | {
        oneofKind: "form";
        /**
         * @generated from protobuf field: c1.api.automations.v1.FormTrigger form = 111
         */
        form: FormTrigger;
    } | {
        oneofKind: "scheduleAppUser";
        /**
         * @generated from protobuf field: c1.api.automations.v1.ScheduleTriggerAppUser schedule_app_user = 112
         */
        scheduleAppUser: ScheduleTriggerAppUser;
    } | {
        oneofKind: "accessConflict";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AccessConflictTrigger access_conflict = 113
         */
        accessConflict: AccessConflictTrigger;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.ManualAutomationTrigger
 */
export interface ManualAutomationTrigger {
}
/**
 * @generated from protobuf message c1.api.automations.v1.UserProfileChangeTrigger
 */
export interface UserProfileChangeTrigger {
    /**
     * @generated from protobuf field: string condition = 3
     */
    condition: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.UserCreatedTrigger
 */
export interface UserCreatedTrigger {
    /**
     * @generated from protobuf field: string condition = 1
     */
    condition: string; // CEL expression that must evaluate to true for the trigger to fire
}
/**
 * @generated from protobuf message c1.api.automations.v1.AppUserCreatedTrigger
 */
export interface AppUserCreatedTrigger {
    /**
     * @generated from protobuf oneof: app_identifier
     */
    appIdentifier: {
        oneofKind: "appId";
        /**
         * @generated from protobuf field: string app_id = 1
         */
        appId: string;
    } | {
        oneofKind: "appIdCel";
        /**
         * @generated from protobuf field: string app_id_cel = 2
         */
        appIdCel: string;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string condition = 3
     */
    condition: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AppUserUpdatedTrigger
 */
export interface AppUserUpdatedTrigger {
    /**
     * @generated from protobuf oneof: app_identifier
     */
    appIdentifier: {
        oneofKind: "appId";
        /**
         * @generated from protobuf field: string app_id = 1
         */
        appId: string;
    } | {
        oneofKind: "appIdCel";
        /**
         * @generated from protobuf field: string app_id_cel = 2
         */
        appIdCel: string;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string condition = 3
     */
    condition: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.UsageBasedRevocationTrigger
 */
export interface UsageBasedRevocationTrigger {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp enabled_at = 2
     */
    enabledAt?: Timestamp;
    /**
     * @generated from protobuf field: uint32 unused_for_days = 3
     */
    unusedForDays: number;
    /**
     * @generated from protobuf field: bool include_users_with_no_activity = 4
     */
    includeUsersWithNoActivity: boolean;
    /**
     * @generated from protobuf oneof: cold_start_schedule
     */
    coldStartSchedule: {
        oneofKind: "runImmediately";
        /**
         * @generated from protobuf field: c1.api.automations.v1.RunImmediately run_immediately = 100
         */
        runImmediately: RunImmediately;
    } | {
        oneofKind: "runDelayed";
        /**
         * @generated from protobuf field: c1.api.automations.v1.RunDelayed run_delayed = 101
         */
        runDelayed: RunDelayed;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserType targeted_app_user_types = 7
     */
    targetedAppUserTypes: AppUserType[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef targeted_entitlement_refs = 8
     */
    targetedEntitlementRefs: AppEntitlementRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef excluded_group_refs = 9
     */
    excludedGroupRefs: AppEntitlementRef[];
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserRef excluded_user_refs = 10
     */
    excludedUserRefs: UserRef[];
}
/**
 * No fields needed; this just indicates the trigger should run immediately
 *
 * @generated from protobuf message c1.api.automations.v1.RunImmediately
 */
export interface RunImmediately {
}
/**
 * @generated from protobuf message c1.api.automations.v1.RunDelayed
 */
export interface RunDelayed {
    /**
     * @generated from protobuf field: uint32 cold_start_delay_days = 1
     */
    coldStartDelayDays: number;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantTriggerFilter
 */
export interface GrantTriggerFilter {
    /**
     * @generated from protobuf field: c1.api.automations.v1.GrantTriggerFilter.GrantFilter grant_filter = 1
     */
    grantFilter?: GrantTriggerFilter_GrantFilter;
    /**
     * @generated from protobuf field: c1.api.automations.v1.GrantTriggerFilter.AccountFilter account_filter = 3
     */
    accountFilter?: GrantTriggerFilter_AccountFilter;
    /**
     * @generated from protobuf oneof: entitlement_inclusion
     */
    entitlementInclusion: {
        oneofKind: "inclusionList";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementInclusionList inclusion_list = 4
         */
        inclusionList: EntitlementInclusionList;
    } | {
        oneofKind: "inclusionAll";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementInclusionAll inclusion_all = 5
         */
        inclusionAll: EntitlementInclusionAll;
    } | {
        oneofKind: "inclusionCriteria";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementInclusionCriteria inclusion_criteria = 6
         */
        inclusionCriteria: EntitlementInclusionCriteria;
    } | {
        oneofKind: "inclusionListCel";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementInclusionListCel inclusion_list_cel = 7
         */
        inclusionListCel: EntitlementInclusionListCel;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantTriggerFilter.GrantFilter
 */
export interface GrantTriggerFilter_GrantFilter {
    /**
     * @generated from protobuf field: c1.api.automations.v1.GrantSourceFilter grant_source_filter = 101
     */
    grantSourceFilter: GrantSourceFilter;
    /**
     * @generated from protobuf field: c1.api.automations.v1.GrantFilterType grant_filter_type = 102
     */
    grantFilterType: GrantFilterType;
    /**
     * @generated from protobuf field: c1.api.automations.v1.GrantJustificationType grant_justification_type = 103
     */
    grantJustificationType: GrantJustificationType;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantTriggerFilter.EntitlementFilter
 */
export interface GrantTriggerFilter_EntitlementFilter {
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantTriggerFilter.AccountFilter
 */
export interface GrantTriggerFilter_AccountFilter {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserType account_type = 301
     */
    accountType: AppUserType;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantFoundTrigger
 */
export interface GrantFoundTrigger {
    /**
     * @generated from protobuf field: c1.api.automations.v1.GrantTriggerFilter grant_trigger_filter = 1
     */
    grantTriggerFilter?: GrantTriggerFilter;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantDeletedTrigger
 */
export interface GrantDeletedTrigger {
    /**
     * @generated from protobuf field: c1.api.automations.v1.GrantTriggerFilter grant_trigger_filter = 1
     */
    grantTriggerFilter?: GrantTriggerFilter;
}
/**
 * @generated from protobuf message c1.api.automations.v1.WebhookAutomationTrigger
 */
export interface WebhookAutomationTrigger {
    /**
     * Auth configuration for the webhook listener
     *
     * @generated from protobuf oneof: auth_config
     */
    authConfig: {
        oneofKind: "jwt";
        /**
         * @generated from protobuf field: c1.api.automations.v1.WebhookListenerAuthJWT jwt = 1
         */
        jwt: WebhookListenerAuthJWT;
    } | {
        oneofKind: "hmac";
        /**
         * @generated from protobuf field: c1.api.automations.v1.WebhookListenerAuthHMAC hmac = 2
         */
        hmac: WebhookListenerAuthHMAC;
    } | {
        oneofKind: undefined;
    };
    /**
     * Optional existing listener ID (hidden field from frontend)
     *
     * @generated from protobuf field: string listener_id = 3
     */
    listenerId: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.FormTrigger
 */
export interface FormTrigger {
    /**
     * @generated from protobuf field: c1.api.form.v1.Form form = 1
     */
    form?: Form;
}
/**
 * @generated from protobuf message c1.api.automations.v1.ConflictMonitorRefs
 */
export interface ConflictMonitorRefs {
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.ConflictMonitorRef conflict_monitor_refs = 1
     */
    conflictMonitorRefs: ConflictMonitorRef[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.AccessConflictTrigger
 */
export interface AccessConflictTrigger {
    /**
     * @generated from protobuf oneof: conflict_monitor_selector
     */
    conflictMonitorSelector: {
        oneofKind: "conflictMonitorRefs";
        /**
         * @generated from protobuf field: c1.api.automations.v1.ConflictMonitorRefs conflict_monitor_refs = 100
         */
        conflictMonitorRefs: ConflictMonitorRefs;
    } | {
        oneofKind: "allConflictMonitors";
        /**
         * @generated from protobuf field: bool all_conflict_monitors = 101
         */
        allConflictMonitors: boolean;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.WebhookListenerAuthJWT
 */
export interface WebhookListenerAuthJWT {
    /**
     * @generated from protobuf field: string jwks_url = 1
     */
    jwksUrl: string;
}
/**
 * This will be generated and encrypted by the backend
 * Frontend should not populate this field directly
 *
 * @generated from protobuf message c1.api.automations.v1.WebhookListenerAuthHMAC
 */
export interface WebhookListenerAuthHMAC {
}
/**
 * @generated from protobuf message c1.api.automations.v1.ScheduleTrigger
 */
export interface ScheduleTrigger {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start = 1
     */
    start?: Timestamp;
    /**
     * @generated from protobuf field: string cron_spec = 2
     */
    cronSpec: string;
    /**
     * @generated from protobuf field: bool advanced = 3
     */
    advanced: boolean;
    /**
     * @deprecated
     * @generated from protobuf field: string skip_if_true_cel = 4 [deprecated = true]
     */
    skipIfTrueCel: string;
    /**
     * @generated from protobuf field: string condition = 5
     */
    condition: string;
    /**
     * @generated from protobuf field: string timezone = 6
     */
    timezone: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.ScheduleTriggerAppUser
 */
export interface ScheduleTriggerAppUser {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start = 1
     */
    start?: Timestamp;
    /**
     * @generated from protobuf field: string cron_spec = 2
     */
    cronSpec: string;
    /**
     * @generated from protobuf field: string condition = 3
     */
    condition: string;
    /**
     * @generated from protobuf field: string app_id = 4
     */
    appId: string;
    /**
     * @generated from protobuf field: string timezone = 5
     */
    timezone: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationTemplateVersion
 */
export interface AutomationTemplateVersion {
    /**
     * @generated from protobuf field: string automation_template_id = 1
     */
    automationTemplateId: string;
    /**
     * @generated from protobuf field: int64 version = 2
     */
    version: number;
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationStep automation_steps = 3
     */
    automationSteps: AutomationStep[];
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationTrigger triggers = 4
     */
    triggers: AutomationTrigger[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf enum c1.api.automations.v1.TriggerType
 */
export enum TriggerType {
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_USER_PROFILE_CHANGE = 2;
     */
    USER_PROFILE_CHANGE = 2,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_APP_USER_CREATE = 3;
     */
    APP_USER_CREATE = 3,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_APP_USER_UPDATE = 4;
     */
    APP_USER_UPDATE = 4,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_UNUSED_ACCESS = 5;
     */
    UNUSED_ACCESS = 5,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_USER_CREATED = 6;
     */
    USER_CREATED = 6,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_GRANT_FOUND = 7;
     */
    GRANT_FOUND = 7,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_GRANT_DELETED = 8;
     */
    GRANT_DELETED = 8,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_WEBHOOK = 9;
     */
    WEBHOOK = 9,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_SCHEDULE = 10;
     */
    SCHEDULE = 10,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_FORM = 11;
     */
    FORM = 11,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_SCHEDULE_APP_USER = 12;
     */
    SCHEDULE_APP_USER = 12,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_ACCESS_CONFLICT = 13;
     */
    ACCESS_CONFLICT = 13
}
/**
 * @generated from protobuf enum c1.api.automations.v1.TaskType
 */
export enum TaskType {
    /**
     * @generated from protobuf enum value: TASK_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TASK_TYPE_REQUEST = 1;
     */
    REQUEST = 1,
    /**
     * @generated from protobuf enum value: TASK_TYPE_REVOKE = 2;
     */
    REVOKE = 2,
    /**
     * @generated from protobuf enum value: TASK_TYPE_REVIEW = 3;
     */
    REVIEW = 3
}
/**
 * @generated from protobuf enum c1.api.automations.v1.TaskUserRelation
 */
export enum TaskUserRelation {
    /**
     * @generated from protobuf enum value: TASK_USER_RELATION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * tasks assigned to user
     *
     * @generated from protobuf enum value: TASK_USER_RELATION_ASSIGNEE = 1;
     */
    ASSIGNEE = 1,
    /**
     * tasks for user
     *
     * @generated from protobuf enum value: TASK_USER_RELATION_SUBJECT = 2;
     */
    SUBJECT = 2
}
/**
 * @generated from protobuf enum c1.api.automations.v1.GrantFilterType
 */
export enum GrantFilterType {
    /**
     * @generated from protobuf enum value: GRANT_FILTER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: GRANT_FILTER_TYPE_PERMANENT = 1;
     */
    PERMANENT = 1,
    /**
     * @generated from protobuf enum value: GRANT_FILTER_TYPE_TEMPORARY = 2;
     */
    TEMPORARY = 2
}
/**
 * @generated from protobuf enum c1.api.automations.v1.GrantSourceFilter
 */
export enum GrantSourceFilter {
    /**
     * @generated from protobuf enum value: GRANT_SOURCE_FILTER_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: GRANT_SOURCE_FILTER_DIRECT = 1;
     */
    DIRECT = 1,
    /**
     * @generated from protobuf enum value: GRANT_SOURCE_FILTER_INHERITED = 2;
     */
    INHERITED = 2
}
/**
 * @generated from protobuf enum c1.api.automations.v1.GrantJustificationType
 */
export enum GrantJustificationType {
    /**
     * @generated from protobuf enum value: GRANT_JUSTIFICATION_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: GRANT_JUSTIFICATION_TYPE_ALL = 1;
     */
    ALL = 1,
    /**
     * @generated from protobuf enum value: GRANT_JUSTIFICATION_TYPE_CONDUCTOR_ONE = 2;
     */
    CONDUCTOR_ONE = 2,
    /**
     * @generated from protobuf enum value: GRANT_JUSTIFICATION_TYPE_DIRECT = 3;
     */
    DIRECT = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class SearchAutomationsRequest$Type extends MessageType<SearchAutomationsRequest> {
    constructor() {
        super("c1.api.automations.v1.SearchAutomationsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "1024" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationTemplateRef },
            { no: 5, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 6, name: "trigger_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.automations.v1.TriggerType", TriggerType, "TRIGGER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAutomationsRequest>): SearchAutomationsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.refs = [];
        message.appId = "";
        message.triggerTypes = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAutomationsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAutomationsRequest): SearchAutomationsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated c1.api.automations.v1.AutomationTemplateRef refs */ 4:
                    message.refs.push(AutomationTemplateRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string app_id */ 5:
                    message.appId = reader.string();
                    break;
                case /* repeated c1.api.automations.v1.TriggerType trigger_types */ 6:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.triggerTypes.push(reader.int32());
                    else
                        message.triggerTypes.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAutomationsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated c1.api.automations.v1.AutomationTemplateRef refs = 4; */
        for (let i = 0; i < message.refs.length; i++)
            AutomationTemplateRef.internalBinaryWrite(message.refs[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string app_id = 5; */
        if (message.appId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.appId);
        /* repeated c1.api.automations.v1.TriggerType trigger_types = 6; */
        if (message.triggerTypes.length) {
            writer.tag(6, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.triggerTypes.length; i++)
                writer.int32(message.triggerTypes[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SearchAutomationsRequest
 */
export const SearchAutomationsRequest = new SearchAutomationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAutomationsResponse$Type extends MessageType<SearchAutomationsResponse> {
    constructor() {
        super("c1.api.automations.v1.SearchAutomationsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Automation },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAutomationsResponse>): SearchAutomationsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAutomationsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAutomationsResponse): SearchAutomationsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.automations.v1.Automation list */ 1:
                    message.list.push(Automation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAutomationsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.automations.v1.Automation list = 1; */
        for (let i = 0; i < message.list.length; i++)
            Automation.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SearchAutomationsResponse
 */
export const SearchAutomationsResponse = new SearchAutomationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAutomationTemplateVersionsRequest$Type extends MessageType<SearchAutomationTemplateVersionsRequest> {
    constructor() {
        super("c1.api.automations.v1.SearchAutomationTemplateVersionsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "automation_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAutomationTemplateVersionsRequest>): SearchAutomationTemplateVersionsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.automationTemplateId = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAutomationTemplateVersionsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAutomationTemplateVersionsRequest): SearchAutomationTemplateVersionsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string automation_template_id */ 3:
                    message.automationTemplateId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAutomationTemplateVersionsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string automation_template_id = 3; */
        if (message.automationTemplateId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.automationTemplateId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SearchAutomationTemplateVersionsRequest
 */
export const SearchAutomationTemplateVersionsRequest = new SearchAutomationTemplateVersionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAutomationTemplateVersionsResponse$Type extends MessageType<SearchAutomationTemplateVersionsResponse> {
    constructor() {
        super("c1.api.automations.v1.SearchAutomationTemplateVersionsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationTemplateVersion },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAutomationTemplateVersionsResponse>): SearchAutomationTemplateVersionsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAutomationTemplateVersionsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAutomationTemplateVersionsResponse): SearchAutomationTemplateVersionsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.automations.v1.AutomationTemplateVersion list */ 1:
                    message.list.push(AutomationTemplateVersion.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAutomationTemplateVersionsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.automations.v1.AutomationTemplateVersion list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AutomationTemplateVersion.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SearchAutomationTemplateVersionsResponse
 */
export const SearchAutomationTemplateVersionsResponse = new SearchAutomationTemplateVersionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAutomationRequest$Type extends MessageType<GetAutomationRequest> {
    constructor() {
        super("c1.api.automations.v1.GetAutomationRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetAutomationRequest>): GetAutomationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<GetAutomationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAutomationRequest): GetAutomationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAutomationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GetAutomationRequest
 */
export const GetAutomationRequest = new GetAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAutomationResponse$Type extends MessageType<GetAutomationResponse> {
    constructor() {
        super("c1.api.automations.v1.GetAutomationResponse", [
            { no: 1, name: "automation", kind: "message", T: () => Automation }
        ]);
    }
    create(value?: PartialMessage<GetAutomationResponse>): GetAutomationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAutomationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAutomationResponse): GetAutomationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.automations.v1.Automation automation */ 1:
                    message.automation = Automation.internalBinaryRead(reader, reader.uint32(), options, message.automation);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAutomationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.automations.v1.Automation automation = 1; */
        if (message.automation)
            Automation.internalBinaryWrite(message.automation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GetAutomationResponse
 */
export const GetAutomationResponse = new GetAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAutomationRequest$Type extends MessageType<CreateAutomationRequest> {
    constructor() {
        super("c1.api.automations.v1.CreateAutomationRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "context", kind: "message", T: () => AutomationContext },
            { no: 5, name: "automation_steps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationStep, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "15" } } } },
            { no: 6, name: "triggers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationTrigger },
            { no: 7, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 8, name: "is_draft", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "draft_automation_steps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationStep },
            { no: 10, name: "draft_triggers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationTrigger }
        ]);
    }
    create(value?: PartialMessage<CreateAutomationRequest>): CreateAutomationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.description = "";
        message.enabled = false;
        message.automationSteps = [];
        message.triggers = [];
        message.appId = "";
        message.isDraft = false;
        message.draftAutomationSteps = [];
        message.draftTriggers = [];
        if (value !== undefined)
            reflectionMergePartial<CreateAutomationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAutomationRequest): CreateAutomationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* bool enabled */ 3:
                    message.enabled = reader.bool();
                    break;
                case /* c1.api.automations.v1.AutomationContext context = 4 [deprecated = true] */ 4:
                    message.context = AutomationContext.internalBinaryRead(reader, reader.uint32(), options, message.context);
                    break;
                case /* repeated c1.api.automations.v1.AutomationStep automation_steps */ 5:
                    message.automationSteps.push(AutomationStep.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.automations.v1.AutomationTrigger triggers */ 6:
                    message.triggers.push(AutomationTrigger.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string app_id */ 7:
                    message.appId = reader.string();
                    break;
                case /* bool is_draft */ 8:
                    message.isDraft = reader.bool();
                    break;
                case /* repeated c1.api.automations.v1.AutomationStep draft_automation_steps */ 9:
                    message.draftAutomationSteps.push(AutomationStep.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.automations.v1.AutomationTrigger draft_triggers */ 10:
                    message.draftTriggers.push(AutomationTrigger.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAutomationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* bool enabled = 3; */
        if (message.enabled !== false)
            writer.tag(3, WireType.Varint).bool(message.enabled);
        /* c1.api.automations.v1.AutomationContext context = 4 [deprecated = true]; */
        if (message.context)
            AutomationContext.internalBinaryWrite(message.context, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.automations.v1.AutomationStep automation_steps = 5; */
        for (let i = 0; i < message.automationSteps.length; i++)
            AutomationStep.internalBinaryWrite(message.automationSteps[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.automations.v1.AutomationTrigger triggers = 6; */
        for (let i = 0; i < message.triggers.length; i++)
            AutomationTrigger.internalBinaryWrite(message.triggers[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string app_id = 7; */
        if (message.appId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.appId);
        /* bool is_draft = 8; */
        if (message.isDraft !== false)
            writer.tag(8, WireType.Varint).bool(message.isDraft);
        /* repeated c1.api.automations.v1.AutomationStep draft_automation_steps = 9; */
        for (let i = 0; i < message.draftAutomationSteps.length; i++)
            AutomationStep.internalBinaryWrite(message.draftAutomationSteps[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.automations.v1.AutomationTrigger draft_triggers = 10; */
        for (let i = 0; i < message.draftTriggers.length; i++)
            AutomationTrigger.internalBinaryWrite(message.draftTriggers[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.CreateAutomationRequest
 */
export const CreateAutomationRequest = new CreateAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAutomationResponse$Type extends MessageType<CreateAutomationResponse> {
    constructor() {
        super("c1.api.automations.v1.CreateAutomationResponse", [
            { no: 1, name: "automation", kind: "message", T: () => Automation },
            { no: 2, name: "webhook_hmac_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateAutomationResponse>): CreateAutomationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.webhookHmacSecret = "";
        if (value !== undefined)
            reflectionMergePartial<CreateAutomationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAutomationResponse): CreateAutomationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.automations.v1.Automation automation */ 1:
                    message.automation = Automation.internalBinaryRead(reader, reader.uint32(), options, message.automation);
                    break;
                case /* string webhook_hmac_secret */ 2:
                    message.webhookHmacSecret = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAutomationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.automations.v1.Automation automation = 1; */
        if (message.automation)
            Automation.internalBinaryWrite(message.automation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string webhook_hmac_secret = 2; */
        if (message.webhookHmacSecret !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.webhookHmacSecret);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.CreateAutomationResponse
 */
export const CreateAutomationResponse = new CreateAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExecuteAutomationRequest$Type extends MessageType<ExecuteAutomationRequest> {
    constructor() {
        super("c1.api.automations.v1.ExecuteAutomationRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "context", kind: "message", T: () => AutomationContext }
        ]);
    }
    create(value?: PartialMessage<ExecuteAutomationRequest>): ExecuteAutomationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ExecuteAutomationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExecuteAutomationRequest): ExecuteAutomationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* c1.api.automations.v1.AutomationContext context */ 2:
                    message.context = AutomationContext.internalBinaryRead(reader, reader.uint32(), options, message.context);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExecuteAutomationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* c1.api.automations.v1.AutomationContext context = 2; */
        if (message.context)
            AutomationContext.internalBinaryWrite(message.context, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ExecuteAutomationRequest
 */
export const ExecuteAutomationRequest = new ExecuteAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExecuteAutomationResponse$Type extends MessageType<ExecuteAutomationResponse> {
    constructor() {
        super("c1.api.automations.v1.ExecuteAutomationResponse", [
            { no: 1, name: "execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<ExecuteAutomationResponse>): ExecuteAutomationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.executionId = 0;
        if (value !== undefined)
            reflectionMergePartial<ExecuteAutomationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExecuteAutomationResponse): ExecuteAutomationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 execution_id */ 1:
                    message.executionId = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExecuteAutomationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 execution_id = 1; */
        if (message.executionId !== 0)
            writer.tag(1, WireType.Varint).int64(message.executionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ExecuteAutomationResponse
 */
export const ExecuteAutomationResponse = new ExecuteAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAutomationRequest$Type extends MessageType<UpdateAutomationRequest> {
    constructor() {
        super("c1.api.automations.v1.UpdateAutomationRequest", [
            { no: 1, name: "automation", kind: "message", T: () => Automation },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<UpdateAutomationRequest>): UpdateAutomationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateAutomationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateAutomationRequest): UpdateAutomationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.automations.v1.Automation automation */ 1:
                    message.automation = Automation.internalBinaryRead(reader, reader.uint32(), options, message.automation);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateAutomationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.automations.v1.Automation automation = 1; */
        if (message.automation)
            Automation.internalBinaryWrite(message.automation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.UpdateAutomationRequest
 */
export const UpdateAutomationRequest = new UpdateAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAutomationResponse$Type extends MessageType<UpdateAutomationResponse> {
    constructor() {
        super("c1.api.automations.v1.UpdateAutomationResponse", [
            { no: 1, name: "automation", kind: "message", T: () => Automation },
            { no: 2, name: "webhook_hmac_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateAutomationResponse>): UpdateAutomationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.webhookHmacSecret = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateAutomationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateAutomationResponse): UpdateAutomationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.automations.v1.Automation automation */ 1:
                    message.automation = Automation.internalBinaryRead(reader, reader.uint32(), options, message.automation);
                    break;
                case /* string webhook_hmac_secret */ 2:
                    message.webhookHmacSecret = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateAutomationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.automations.v1.Automation automation = 1; */
        if (message.automation)
            Automation.internalBinaryWrite(message.automation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string webhook_hmac_secret = 2; */
        if (message.webhookHmacSecret !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.webhookHmacSecret);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.UpdateAutomationResponse
 */
export const UpdateAutomationResponse = new UpdateAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAutomationRequest$Type extends MessageType<DeleteAutomationRequest> {
    constructor() {
        super("c1.api.automations.v1.DeleteAutomationRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<DeleteAutomationRequest>): DeleteAutomationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteAutomationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAutomationRequest): DeleteAutomationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAutomationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.DeleteAutomationRequest
 */
export const DeleteAutomationRequest = new DeleteAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAutomationResponse$Type extends MessageType<DeleteAutomationResponse> {
    constructor() {
        super("c1.api.automations.v1.DeleteAutomationResponse", []);
    }
    create(value?: PartialMessage<DeleteAutomationResponse>): DeleteAutomationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteAutomationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAutomationResponse): DeleteAutomationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAutomationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.DeleteAutomationResponse
 */
export const DeleteAutomationResponse = new DeleteAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAutomationsRequest$Type extends MessageType<ListAutomationsRequest> {
    constructor() {
        super("c1.api.automations.v1.ListAutomationsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ListAutomationsRequest>): ListAutomationsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAutomationsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAutomationsRequest): ListAutomationsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAutomationsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ListAutomationsRequest
 */
export const ListAutomationsRequest = new ListAutomationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAutomationsResponse$Type extends MessageType<ListAutomationsResponse> {
    constructor() {
        super("c1.api.automations.v1.ListAutomationsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Automation },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListAutomationsResponse>): ListAutomationsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAutomationsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAutomationsResponse): ListAutomationsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.automations.v1.Automation list */ 1:
                    message.list.push(Automation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAutomationsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.automations.v1.Automation list = 1; */
        for (let i = 0; i < message.list.length; i++)
            Automation.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ListAutomationsResponse
 */
export const ListAutomationsResponse = new ListAutomationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Automation$Type extends MessageType<Automation> {
    constructor() {
        super("c1.api.automations.v1.Automation", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "1024" } } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 101, name: "circuit_breaker", kind: "message", oneof: "disabledReason", T: () => DisabledReasonCircuitBreaker },
            { no: 5, name: "context", kind: "message", T: () => AutomationContext },
            { no: 6, name: "automation_steps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationStep },
            { no: 7, name: "triggers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationTrigger },
            { no: 15, name: "primary_trigger_type", kind: "enum", T: () => ["c1.api.automations.v1.TriggerType", TriggerType, "TRIGGER_TYPE_"], options: { "validate.rules": { enum: { definedOnly: true } } } },
            { no: 8, name: "last_executed_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 10, name: "draft_automation_steps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationStep },
            { no: 11, name: "draft_triggers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationTrigger },
            { no: 12, name: "is_draft", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "current_version", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 14, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Automation" } }] } });
    }
    create(value?: PartialMessage<Automation>): Automation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.description = "";
        message.enabled = false;
        message.disabledReason = { oneofKind: undefined };
        message.automationSteps = [];
        message.triggers = [];
        message.primaryTriggerType = 0;
        message.draftAutomationSteps = [];
        message.draftTriggers = [];
        message.isDraft = false;
        message.currentVersion = 0;
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<Automation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Automation): Automation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* bool enabled */ 4:
                    message.enabled = reader.bool();
                    break;
                case /* c1.api.automations.v1.DisabledReasonCircuitBreaker circuit_breaker */ 101:
                    message.disabledReason = {
                        oneofKind: "circuitBreaker",
                        circuitBreaker: DisabledReasonCircuitBreaker.internalBinaryRead(reader, reader.uint32(), options, (message.disabledReason as any).circuitBreaker)
                    };
                    break;
                case /* c1.api.automations.v1.AutomationContext context = 5 [deprecated = true] */ 5:
                    message.context = AutomationContext.internalBinaryRead(reader, reader.uint32(), options, message.context);
                    break;
                case /* repeated c1.api.automations.v1.AutomationStep automation_steps */ 6:
                    message.automationSteps.push(AutomationStep.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.automations.v1.AutomationTrigger triggers */ 7:
                    message.triggers.push(AutomationTrigger.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.automations.v1.TriggerType primary_trigger_type */ 15:
                    message.primaryTriggerType = reader.int32();
                    break;
                case /* google.protobuf.Timestamp last_executed_at */ 8:
                    message.lastExecutedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastExecutedAt);
                    break;
                case /* google.protobuf.Timestamp created_at */ 9:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* repeated c1.api.automations.v1.AutomationStep draft_automation_steps */ 10:
                    message.draftAutomationSteps.push(AutomationStep.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.automations.v1.AutomationTrigger draft_triggers */ 11:
                    message.draftTriggers.push(AutomationTrigger.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool is_draft */ 12:
                    message.isDraft = reader.bool();
                    break;
                case /* int64 current_version */ 13:
                    message.currentVersion = reader.int64().toNumber();
                    break;
                case /* string app_id */ 14:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Automation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* bool enabled = 4; */
        if (message.enabled !== false)
            writer.tag(4, WireType.Varint).bool(message.enabled);
        /* c1.api.automations.v1.AutomationContext context = 5 [deprecated = true]; */
        if (message.context)
            AutomationContext.internalBinaryWrite(message.context, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.automations.v1.AutomationStep automation_steps = 6; */
        for (let i = 0; i < message.automationSteps.length; i++)
            AutomationStep.internalBinaryWrite(message.automationSteps[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.automations.v1.AutomationTrigger triggers = 7; */
        for (let i = 0; i < message.triggers.length; i++)
            AutomationTrigger.internalBinaryWrite(message.triggers[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp last_executed_at = 8; */
        if (message.lastExecutedAt)
            Timestamp.internalBinaryWrite(message.lastExecutedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 9; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.automations.v1.AutomationStep draft_automation_steps = 10; */
        for (let i = 0; i < message.draftAutomationSteps.length; i++)
            AutomationStep.internalBinaryWrite(message.draftAutomationSteps[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.automations.v1.AutomationTrigger draft_triggers = 11; */
        for (let i = 0; i < message.draftTriggers.length; i++)
            AutomationTrigger.internalBinaryWrite(message.draftTriggers[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* bool is_draft = 12; */
        if (message.isDraft !== false)
            writer.tag(12, WireType.Varint).bool(message.isDraft);
        /* int64 current_version = 13; */
        if (message.currentVersion !== 0)
            writer.tag(13, WireType.Varint).int64(message.currentVersion);
        /* string app_id = 14; */
        if (message.appId !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.appId);
        /* c1.api.automations.v1.TriggerType primary_trigger_type = 15; */
        if (message.primaryTriggerType !== 0)
            writer.tag(15, WireType.Varint).int32(message.primaryTriggerType);
        /* c1.api.automations.v1.DisabledReasonCircuitBreaker circuit_breaker = 101; */
        if (message.disabledReason.oneofKind === "circuitBreaker")
            DisabledReasonCircuitBreaker.internalBinaryWrite(message.disabledReason.circuitBreaker, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.Automation
 */
export const Automation = new Automation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DisabledReasonCircuitBreaker$Type extends MessageType<DisabledReasonCircuitBreaker> {
    constructor() {
        super("c1.api.automations.v1.DisabledReasonCircuitBreaker", []);
    }
    create(value?: PartialMessage<DisabledReasonCircuitBreaker>): DisabledReasonCircuitBreaker {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DisabledReasonCircuitBreaker>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DisabledReasonCircuitBreaker): DisabledReasonCircuitBreaker {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DisabledReasonCircuitBreaker, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.DisabledReasonCircuitBreaker
 */
export const DisabledReasonCircuitBreaker = new DisabledReasonCircuitBreaker$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationTemplateRef$Type extends MessageType<AutomationTemplateRef> {
    constructor() {
        super("c1.api.automations.v1.AutomationTemplateRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AutomationTemplateRef>): AutomationTemplateRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<AutomationTemplateRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AutomationTemplateRef): AutomationTemplateRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AutomationTemplateRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationTemplateRef
 */
export const AutomationTemplateRef = new AutomationTemplateRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationStep$Type extends MessageType<AutomationStep> {
    constructor() {
        super("c1.api.automations.v1.AutomationStep", [
            { no: 1, name: "step_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 101, name: "create_access_review", kind: "message", oneof: "kind", T: () => CreateAccessReview },
            { no: 102, name: "wait_for_duration", kind: "message", oneof: "kind", T: () => WaitForDuration },
            { no: 103, name: "unenroll_from_all_access_profiles", kind: "message", oneof: "kind", T: () => UnenrollFromAllAccessProfiles },
            { no: 104, name: "create_revoke_tasks", kind: "message", oneof: "kind", T: () => CreateRevokeTasks },
            { no: 117, name: "create_revoke_tasks_v2", kind: "message", oneof: "kind", T: () => CreateRevokeTasksV2 },
            { no: 105, name: "send_email", kind: "message", oneof: "kind", T: () => SendEmail },
            { no: 106, name: "remove_from_delegation", kind: "message", oneof: "kind", T: () => RemoveFromDelegation },
            { no: 107, name: "run_automation", kind: "message", oneof: "kind", T: () => RunAutomation },
            { no: 108, name: "update_user", kind: "message", oneof: "kind", T: () => UpdateUser },
            { no: 109, name: "task_action", kind: "message", oneof: "kind", T: () => TaskAction },
            { no: 110, name: "webhook", kind: "message", oneof: "kind", T: () => Webhook },
            { no: 111, name: "connector_action", kind: "message", oneof: "kind", T: () => ConnectorAction },
            { no: 112, name: "connector_create_account", kind: "message", oneof: "kind", T: () => ConnectorCreateAccount },
            { no: 113, name: "grant_entitlements", kind: "message", oneof: "kind", T: () => GrantEntitlements },
            { no: 114, name: "send_slack_message", kind: "message", oneof: "kind", T: () => SendSlackMessage },
            { no: 115, name: "call_function", kind: "message", oneof: "kind", T: () => CallFunction },
            { no: 116, name: "account_lifecycle_action", kind: "message", oneof: "kind", T: () => AccountLifecycleAction },
            { no: 120, name: "generate_password", kind: "message", oneof: "kind", T: () => GeneratePassword },
            { no: 121, name: "evaluate_expressions", kind: "message", oneof: "kind", T: () => EvaluateExpressions },
            { no: 2, name: "skip_if_true_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 3, name: "step_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<AutomationStep>): AutomationStep {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stepName = "";
        message.kind = { oneofKind: undefined };
        message.skipIfTrueCel = "";
        message.stepDisplayName = "";
        if (value !== undefined)
            reflectionMergePartial<AutomationStep>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AutomationStep): AutomationStep {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string step_name */ 1:
                    message.stepName = reader.string();
                    break;
                case /* c1.api.automations.v1.CreateAccessReview create_access_review */ 101:
                    message.kind = {
                        oneofKind: "createAccessReview",
                        createAccessReview: CreateAccessReview.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).createAccessReview)
                    };
                    break;
                case /* c1.api.automations.v1.WaitForDuration wait_for_duration */ 102:
                    message.kind = {
                        oneofKind: "waitForDuration",
                        waitForDuration: WaitForDuration.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).waitForDuration)
                    };
                    break;
                case /* c1.api.automations.v1.UnenrollFromAllAccessProfiles unenroll_from_all_access_profiles */ 103:
                    message.kind = {
                        oneofKind: "unenrollFromAllAccessProfiles",
                        unenrollFromAllAccessProfiles: UnenrollFromAllAccessProfiles.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).unenrollFromAllAccessProfiles)
                    };
                    break;
                case /* c1.api.automations.v1.CreateRevokeTasks create_revoke_tasks = 104 [deprecated = true] */ 104:
                    message.kind = {
                        oneofKind: "createRevokeTasks",
                        createRevokeTasks: CreateRevokeTasks.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).createRevokeTasks)
                    };
                    break;
                case /* c1.api.automations.v1.CreateRevokeTasksV2 create_revoke_tasks_v2 */ 117:
                    message.kind = {
                        oneofKind: "createRevokeTasksV2",
                        createRevokeTasksV2: CreateRevokeTasksV2.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).createRevokeTasksV2)
                    };
                    break;
                case /* c1.api.automations.v1.SendEmail send_email */ 105:
                    message.kind = {
                        oneofKind: "sendEmail",
                        sendEmail: SendEmail.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).sendEmail)
                    };
                    break;
                case /* c1.api.automations.v1.RemoveFromDelegation remove_from_delegation */ 106:
                    message.kind = {
                        oneofKind: "removeFromDelegation",
                        removeFromDelegation: RemoveFromDelegation.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).removeFromDelegation)
                    };
                    break;
                case /* c1.api.automations.v1.RunAutomation run_automation */ 107:
                    message.kind = {
                        oneofKind: "runAutomation",
                        runAutomation: RunAutomation.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).runAutomation)
                    };
                    break;
                case /* c1.api.automations.v1.UpdateUser update_user */ 108:
                    message.kind = {
                        oneofKind: "updateUser",
                        updateUser: UpdateUser.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).updateUser)
                    };
                    break;
                case /* c1.api.automations.v1.TaskAction task_action */ 109:
                    message.kind = {
                        oneofKind: "taskAction",
                        taskAction: TaskAction.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).taskAction)
                    };
                    break;
                case /* c1.api.automations.v1.Webhook webhook */ 110:
                    message.kind = {
                        oneofKind: "webhook",
                        webhook: Webhook.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).webhook)
                    };
                    break;
                case /* c1.api.automations.v1.ConnectorAction connector_action */ 111:
                    message.kind = {
                        oneofKind: "connectorAction",
                        connectorAction: ConnectorAction.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).connectorAction)
                    };
                    break;
                case /* c1.api.automations.v1.ConnectorCreateAccount connector_create_account */ 112:
                    message.kind = {
                        oneofKind: "connectorCreateAccount",
                        connectorCreateAccount: ConnectorCreateAccount.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).connectorCreateAccount)
                    };
                    break;
                case /* c1.api.automations.v1.GrantEntitlements grant_entitlements */ 113:
                    message.kind = {
                        oneofKind: "grantEntitlements",
                        grantEntitlements: GrantEntitlements.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).grantEntitlements)
                    };
                    break;
                case /* c1.api.automations.v1.SendSlackMessage send_slack_message */ 114:
                    message.kind = {
                        oneofKind: "sendSlackMessage",
                        sendSlackMessage: SendSlackMessage.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).sendSlackMessage)
                    };
                    break;
                case /* c1.api.automations.v1.CallFunction call_function */ 115:
                    message.kind = {
                        oneofKind: "callFunction",
                        callFunction: CallFunction.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).callFunction)
                    };
                    break;
                case /* c1.api.automations.v1.AccountLifecycleAction account_lifecycle_action */ 116:
                    message.kind = {
                        oneofKind: "accountLifecycleAction",
                        accountLifecycleAction: AccountLifecycleAction.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).accountLifecycleAction)
                    };
                    break;
                case /* c1.api.automations.v1.GeneratePassword generate_password */ 120:
                    message.kind = {
                        oneofKind: "generatePassword",
                        generatePassword: GeneratePassword.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).generatePassword)
                    };
                    break;
                case /* c1.api.automations.v1.EvaluateExpressions evaluate_expressions */ 121:
                    message.kind = {
                        oneofKind: "evaluateExpressions",
                        evaluateExpressions: EvaluateExpressions.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).evaluateExpressions)
                    };
                    break;
                case /* string skip_if_true_cel */ 2:
                    message.skipIfTrueCel = reader.string();
                    break;
                case /* string step_display_name */ 3:
                    message.stepDisplayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AutomationStep, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string step_name = 1; */
        if (message.stepName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stepName);
        /* string skip_if_true_cel = 2; */
        if (message.skipIfTrueCel !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.skipIfTrueCel);
        /* string step_display_name = 3; */
        if (message.stepDisplayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.stepDisplayName);
        /* c1.api.automations.v1.CreateAccessReview create_access_review = 101; */
        if (message.kind.oneofKind === "createAccessReview")
            CreateAccessReview.internalBinaryWrite(message.kind.createAccessReview, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.WaitForDuration wait_for_duration = 102; */
        if (message.kind.oneofKind === "waitForDuration")
            WaitForDuration.internalBinaryWrite(message.kind.waitForDuration, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.UnenrollFromAllAccessProfiles unenroll_from_all_access_profiles = 103; */
        if (message.kind.oneofKind === "unenrollFromAllAccessProfiles")
            UnenrollFromAllAccessProfiles.internalBinaryWrite(message.kind.unenrollFromAllAccessProfiles, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.CreateRevokeTasks create_revoke_tasks = 104 [deprecated = true]; */
        if (message.kind.oneofKind === "createRevokeTasks")
            CreateRevokeTasks.internalBinaryWrite(message.kind.createRevokeTasks, writer.tag(104, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.SendEmail send_email = 105; */
        if (message.kind.oneofKind === "sendEmail")
            SendEmail.internalBinaryWrite(message.kind.sendEmail, writer.tag(105, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.RemoveFromDelegation remove_from_delegation = 106; */
        if (message.kind.oneofKind === "removeFromDelegation")
            RemoveFromDelegation.internalBinaryWrite(message.kind.removeFromDelegation, writer.tag(106, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.RunAutomation run_automation = 107; */
        if (message.kind.oneofKind === "runAutomation")
            RunAutomation.internalBinaryWrite(message.kind.runAutomation, writer.tag(107, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.UpdateUser update_user = 108; */
        if (message.kind.oneofKind === "updateUser")
            UpdateUser.internalBinaryWrite(message.kind.updateUser, writer.tag(108, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.TaskAction task_action = 109; */
        if (message.kind.oneofKind === "taskAction")
            TaskAction.internalBinaryWrite(message.kind.taskAction, writer.tag(109, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.Webhook webhook = 110; */
        if (message.kind.oneofKind === "webhook")
            Webhook.internalBinaryWrite(message.kind.webhook, writer.tag(110, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.ConnectorAction connector_action = 111; */
        if (message.kind.oneofKind === "connectorAction")
            ConnectorAction.internalBinaryWrite(message.kind.connectorAction, writer.tag(111, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.ConnectorCreateAccount connector_create_account = 112; */
        if (message.kind.oneofKind === "connectorCreateAccount")
            ConnectorCreateAccount.internalBinaryWrite(message.kind.connectorCreateAccount, writer.tag(112, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.GrantEntitlements grant_entitlements = 113; */
        if (message.kind.oneofKind === "grantEntitlements")
            GrantEntitlements.internalBinaryWrite(message.kind.grantEntitlements, writer.tag(113, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.SendSlackMessage send_slack_message = 114; */
        if (message.kind.oneofKind === "sendSlackMessage")
            SendSlackMessage.internalBinaryWrite(message.kind.sendSlackMessage, writer.tag(114, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.CallFunction call_function = 115; */
        if (message.kind.oneofKind === "callFunction")
            CallFunction.internalBinaryWrite(message.kind.callFunction, writer.tag(115, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.AccountLifecycleAction account_lifecycle_action = 116; */
        if (message.kind.oneofKind === "accountLifecycleAction")
            AccountLifecycleAction.internalBinaryWrite(message.kind.accountLifecycleAction, writer.tag(116, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.CreateRevokeTasksV2 create_revoke_tasks_v2 = 117; */
        if (message.kind.oneofKind === "createRevokeTasksV2")
            CreateRevokeTasksV2.internalBinaryWrite(message.kind.createRevokeTasksV2, writer.tag(117, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.GeneratePassword generate_password = 120; */
        if (message.kind.oneofKind === "generatePassword")
            GeneratePassword.internalBinaryWrite(message.kind.generatePassword, writer.tag(120, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.EvaluateExpressions evaluate_expressions = 121; */
        if (message.kind.oneofKind === "evaluateExpressions")
            EvaluateExpressions.internalBinaryWrite(message.kind.evaluateExpressions, writer.tag(121, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationStep
 */
export const AutomationStep = new AutomationStep$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SendEmail$Type extends MessageType<SendEmail> {
    constructor() {
        super("c1.api.automations.v1.SendEmail", [
            { no: 1, name: "subject", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "body", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "8192" } } } },
            { no: 3, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "user_ids_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "use_subject_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SendEmail>): SendEmail {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subject = "";
        message.body = "";
        message.title = "";
        message.userRefs = [];
        message.userIdsCel = "";
        message.useSubjectUser = false;
        if (value !== undefined)
            reflectionMergePartial<SendEmail>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SendEmail): SendEmail {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string subject */ 1:
                    message.subject = reader.string();
                    break;
                case /* string body */ 2:
                    message.body = reader.string();
                    break;
                case /* string title */ 3:
                    message.title = reader.string();
                    break;
                case /* repeated c1.api.user.v1.UserRef user_refs */ 4:
                    message.userRefs.push(UserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string user_ids_cel */ 5:
                    message.userIdsCel = reader.string();
                    break;
                case /* bool use_subject_user */ 6:
                    message.useSubjectUser = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SendEmail, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string subject = 1; */
        if (message.subject !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.subject);
        /* string body = 2; */
        if (message.body !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.body);
        /* string title = 3; */
        if (message.title !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.title);
        /* repeated c1.api.user.v1.UserRef user_refs = 4; */
        for (let i = 0; i < message.userRefs.length; i++)
            UserRef.internalBinaryWrite(message.userRefs[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string user_ids_cel = 5; */
        if (message.userIdsCel !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.userIdsCel);
        /* bool use_subject_user = 6; */
        if (message.useSubjectUser !== false)
            writer.tag(6, WireType.Varint).bool(message.useSubjectUser);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SendEmail
 */
export const SendEmail = new SendEmail$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SendSlackMessage$Type extends MessageType<SendSlackMessage> {
    constructor() {
        super("c1.api.automations.v1.SendSlackMessage", [
            { no: 1, name: "body", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "channel_name", kind: "scalar", oneof: "channel", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "channel_name_cel", kind: "scalar", oneof: "channel", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<SendSlackMessage>): SendSlackMessage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.body = "";
        message.channel = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<SendSlackMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SendSlackMessage): SendSlackMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string body */ 1:
                    message.body = reader.string();
                    break;
                case /* string channel_name */ 2:
                    message.channel = {
                        oneofKind: "channelName",
                        channelName: reader.string()
                    };
                    break;
                case /* string channel_name_cel */ 3:
                    message.channel = {
                        oneofKind: "channelNameCel",
                        channelNameCel: reader.string()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SendSlackMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string body = 1; */
        if (message.body !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.body);
        /* string channel_name = 2; */
        if (message.channel.oneofKind === "channelName")
            writer.tag(2, WireType.LengthDelimited).string(message.channel.channelName);
        /* string channel_name_cel = 3; */
        if (message.channel.oneofKind === "channelNameCel")
            writer.tag(3, WireType.LengthDelimited).string(message.channel.channelNameCel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SendSlackMessage
 */
export const SendSlackMessage = new SendSlackMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CallFunction$Type extends MessageType<CallFunction> {
    constructor() {
        super("c1.api.automations.v1.CallFunction", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "args", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value?: PartialMessage<CallFunction>): CallFunction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.functionId = "";
        message.args = {};
        if (value !== undefined)
            reflectionMergePartial<CallFunction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CallFunction): CallFunction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string function_id */ 1:
                    message.functionId = reader.string();
                    break;
                case /* map<string, string> args */ 2:
                    this.binaryReadMap2(message.args, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: CallFunction["args"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CallFunction["args"] | undefined, val: CallFunction["args"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.automations.v1.CallFunction.args");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: CallFunction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string function_id = 1; */
        if (message.functionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.functionId);
        /* map<string, string> args = 2; */
        for (let k of globalThis.Object.keys(message.args))
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.args[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.CallFunction
 */
export const CallFunction = new CallFunction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccessReview$Type extends MessageType<CreateAccessReview> {
    constructor() {
        super("c1.api.automations.v1.CreateAccessReview", [
            { no: 1, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "access_review_template_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_ids_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "use_subject_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "campaign_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "512", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<CreateAccessReview>): CreateAccessReview {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewTemplateId = "";
        message.accessReviewTemplateCel = "";
        message.userIdsCel = "";
        message.userRefs = [];
        message.useSubjectUser = false;
        message.campaignName = "";
        if (value !== undefined)
            reflectionMergePartial<CreateAccessReview>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAccessReview): CreateAccessReview {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_template_id */ 1:
                    message.accessReviewTemplateId = reader.string();
                    break;
                case /* string access_review_template_cel */ 2:
                    message.accessReviewTemplateCel = reader.string();
                    break;
                case /* string user_ids_cel */ 3:
                    message.userIdsCel = reader.string();
                    break;
                case /* repeated c1.api.user.v1.UserRef user_refs */ 4:
                    message.userRefs.push(UserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool use_subject_user */ 5:
                    message.useSubjectUser = reader.bool();
                    break;
                case /* string campaign_name */ 6:
                    message.campaignName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAccessReview, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_template_id = 1; */
        if (message.accessReviewTemplateId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewTemplateId);
        /* string access_review_template_cel = 2; */
        if (message.accessReviewTemplateCel !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.accessReviewTemplateCel);
        /* string user_ids_cel = 3; */
        if (message.userIdsCel !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.userIdsCel);
        /* repeated c1.api.user.v1.UserRef user_refs = 4; */
        for (let i = 0; i < message.userRefs.length; i++)
            UserRef.internalBinaryWrite(message.userRefs[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool use_subject_user = 5; */
        if (message.useSubjectUser !== false)
            writer.tag(5, WireType.Varint).bool(message.useSubjectUser);
        /* string campaign_name = 6; */
        if (message.campaignName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.campaignName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.CreateAccessReview
 */
export const CreateAccessReview = new CreateAccessReview$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WaitForDuration$Type extends MessageType<WaitForDuration> {
    constructor() {
        super("c1.api.automations.v1.WaitForDuration", [
            { no: 1, name: "duration", kind: "message", T: () => Duration }
        ]);
    }
    create(value?: PartialMessage<WaitForDuration>): WaitForDuration {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WaitForDuration>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WaitForDuration): WaitForDuration {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Duration duration */ 1:
                    message.duration = Duration.internalBinaryRead(reader, reader.uint32(), options, message.duration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WaitForDuration, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Duration duration = 1; */
        if (message.duration)
            Duration.internalBinaryWrite(message.duration, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.WaitForDuration
 */
export const WaitForDuration = new WaitForDuration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnenrollFromAllAccessProfiles$Type extends MessageType<UnenrollFromAllAccessProfiles> {
    constructor() {
        super("c1.api.automations.v1.UnenrollFromAllAccessProfiles", [
            { no: 1, name: "user_ids_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 3, name: "catalog_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "catalog_ids_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "use_subject_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UnenrollFromAllAccessProfiles>): UnenrollFromAllAccessProfiles {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userIdsCel = "";
        message.userRefs = [];
        message.catalogIds = [];
        message.catalogIdsCel = "";
        message.useSubjectUser = false;
        if (value !== undefined)
            reflectionMergePartial<UnenrollFromAllAccessProfiles>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UnenrollFromAllAccessProfiles): UnenrollFromAllAccessProfiles {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_ids_cel */ 1:
                    message.userIdsCel = reader.string();
                    break;
                case /* repeated c1.api.user.v1.UserRef user_refs */ 2:
                    message.userRefs.push(UserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string catalog_ids */ 3:
                    message.catalogIds.push(reader.string());
                    break;
                case /* string catalog_ids_cel */ 5:
                    message.catalogIdsCel = reader.string();
                    break;
                case /* bool use_subject_user */ 4:
                    message.useSubjectUser = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UnenrollFromAllAccessProfiles, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_ids_cel = 1; */
        if (message.userIdsCel !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userIdsCel);
        /* repeated c1.api.user.v1.UserRef user_refs = 2; */
        for (let i = 0; i < message.userRefs.length; i++)
            UserRef.internalBinaryWrite(message.userRefs[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated string catalog_ids = 3; */
        for (let i = 0; i < message.catalogIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.catalogIds[i]);
        /* bool use_subject_user = 4; */
        if (message.useSubjectUser !== false)
            writer.tag(4, WireType.Varint).bool(message.useSubjectUser);
        /* string catalog_ids_cel = 5; */
        if (message.catalogIdsCel !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.catalogIdsCel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.UnenrollFromAllAccessProfiles
 */
export const UnenrollFromAllAccessProfiles = new UnenrollFromAllAccessProfiles$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRevokeTasks$Type extends MessageType<CreateRevokeTasks> {
    constructor() {
        super("c1.api.automations.v1.CreateRevokeTasks", [
            { no: 1, name: "user_id_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_ref", kind: "message", T: () => UserRef, options: { "validate.rules": { message: { required: false } } } },
            { no: 3, name: "app_entitlement_refs_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "revoke_all", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "use_subject_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "excluded_app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 8, name: "excluded_app_entitlement_refs_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateRevokeTasks>): CreateRevokeTasks {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userIdCel = "";
        message.appEntitlementRefsCel = "";
        message.appEntitlementRefs = [];
        message.revokeAll = false;
        message.useSubjectUser = false;
        message.excludedAppEntitlementRefs = [];
        message.excludedAppEntitlementRefsCel = "";
        if (value !== undefined)
            reflectionMergePartial<CreateRevokeTasks>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateRevokeTasks): CreateRevokeTasks {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id_cel */ 1:
                    message.userIdCel = reader.string();
                    break;
                case /* c1.api.user.v1.UserRef user_ref */ 2:
                    message.userRef = UserRef.internalBinaryRead(reader, reader.uint32(), options, message.userRef);
                    break;
                case /* string app_entitlement_refs_cel */ 3:
                    message.appEntitlementRefsCel = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs */ 4:
                    message.appEntitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool revoke_all */ 5:
                    message.revokeAll = reader.bool();
                    break;
                case /* bool use_subject_user */ 6:
                    message.useSubjectUser = reader.bool();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef excluded_app_entitlement_refs */ 7:
                    message.excludedAppEntitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string excluded_app_entitlement_refs_cel */ 8:
                    message.excludedAppEntitlementRefsCel = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateRevokeTasks, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id_cel = 1; */
        if (message.userIdCel !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userIdCel);
        /* c1.api.user.v1.UserRef user_ref = 2; */
        if (message.userRef)
            UserRef.internalBinaryWrite(message.userRef, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string app_entitlement_refs_cel = 3; */
        if (message.appEntitlementRefsCel !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appEntitlementRefsCel);
        /* repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 4; */
        for (let i = 0; i < message.appEntitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.appEntitlementRefs[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool revoke_all = 5; */
        if (message.revokeAll !== false)
            writer.tag(5, WireType.Varint).bool(message.revokeAll);
        /* bool use_subject_user = 6; */
        if (message.useSubjectUser !== false)
            writer.tag(6, WireType.Varint).bool(message.useSubjectUser);
        /* repeated c1.api.app.v1.AppEntitlementRef excluded_app_entitlement_refs = 7; */
        for (let i = 0; i < message.excludedAppEntitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.excludedAppEntitlementRefs[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string excluded_app_entitlement_refs_cel = 8; */
        if (message.excludedAppEntitlementRefsCel !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.excludedAppEntitlementRefsCel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.CreateRevokeTasks
 */
export const CreateRevokeTasks = new CreateRevokeTasks$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRevokeTasksV2$Type extends MessageType<CreateRevokeTasksV2> {
    constructor() {
        super("c1.api.automations.v1.CreateRevokeTasksV2", [
            { no: 1, name: "user_id_cel", kind: "scalar", oneof: "user", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_ref", kind: "message", oneof: "user", T: () => UserRef, options: { "validate.rules": { message: { required: false } } } },
            { no: 3, name: "use_subject_user", kind: "scalar", oneof: "user", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "inclusion_list", kind: "message", oneof: "inclusion", T: () => EntitlementInclusionList },
            { no: 5, name: "inclusion_all", kind: "message", oneof: "inclusion", T: () => EntitlementInclusionAll },
            { no: 6, name: "inclusion_criteria", kind: "message", oneof: "inclusion", T: () => EntitlementInclusionCriteria },
            { no: 20, name: "inclusion_list_cel", kind: "message", oneof: "inclusion", T: () => EntitlementInclusionListCel },
            { no: 7, name: "exclusion_none", kind: "message", oneof: "exclusion", T: () => EntitlementExclusionNone },
            { no: 8, name: "exclusion_list", kind: "message", oneof: "exclusion", T: () => EntitlementExclusionList },
            { no: 9, name: "exclusion_criteria", kind: "message", oneof: "exclusion", T: () => EntitlementExclusionCriteria },
            { no: 30, name: "exclusion_list_cel", kind: "message", oneof: "exclusion", T: () => EntitlementExclusionListCel }
        ]);
    }
    create(value?: PartialMessage<CreateRevokeTasksV2>): CreateRevokeTasksV2 {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.user = { oneofKind: undefined };
        message.inclusion = { oneofKind: undefined };
        message.exclusion = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<CreateRevokeTasksV2>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateRevokeTasksV2): CreateRevokeTasksV2 {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id_cel */ 1:
                    message.user = {
                        oneofKind: "userIdCel",
                        userIdCel: reader.string()
                    };
                    break;
                case /* c1.api.user.v1.UserRef user_ref */ 2:
                    message.user = {
                        oneofKind: "userRef",
                        userRef: UserRef.internalBinaryRead(reader, reader.uint32(), options, (message.user as any).userRef)
                    };
                    break;
                case /* bool use_subject_user */ 3:
                    message.user = {
                        oneofKind: "useSubjectUser",
                        useSubjectUser: reader.bool()
                    };
                    break;
                case /* c1.api.automations.v1.EntitlementInclusionList inclusion_list */ 4:
                    message.inclusion = {
                        oneofKind: "inclusionList",
                        inclusionList: EntitlementInclusionList.internalBinaryRead(reader, reader.uint32(), options, (message.inclusion as any).inclusionList)
                    };
                    break;
                case /* c1.api.automations.v1.EntitlementInclusionAll inclusion_all */ 5:
                    message.inclusion = {
                        oneofKind: "inclusionAll",
                        inclusionAll: EntitlementInclusionAll.internalBinaryRead(reader, reader.uint32(), options, (message.inclusion as any).inclusionAll)
                    };
                    break;
                case /* c1.api.automations.v1.EntitlementInclusionCriteria inclusion_criteria */ 6:
                    message.inclusion = {
                        oneofKind: "inclusionCriteria",
                        inclusionCriteria: EntitlementInclusionCriteria.internalBinaryRead(reader, reader.uint32(), options, (message.inclusion as any).inclusionCriteria)
                    };
                    break;
                case /* c1.api.automations.v1.EntitlementInclusionListCel inclusion_list_cel */ 20:
                    message.inclusion = {
                        oneofKind: "inclusionListCel",
                        inclusionListCel: EntitlementInclusionListCel.internalBinaryRead(reader, reader.uint32(), options, (message.inclusion as any).inclusionListCel)
                    };
                    break;
                case /* c1.api.automations.v1.EntitlementExclusionNone exclusion_none */ 7:
                    message.exclusion = {
                        oneofKind: "exclusionNone",
                        exclusionNone: EntitlementExclusionNone.internalBinaryRead(reader, reader.uint32(), options, (message.exclusion as any).exclusionNone)
                    };
                    break;
                case /* c1.api.automations.v1.EntitlementExclusionList exclusion_list */ 8:
                    message.exclusion = {
                        oneofKind: "exclusionList",
                        exclusionList: EntitlementExclusionList.internalBinaryRead(reader, reader.uint32(), options, (message.exclusion as any).exclusionList)
                    };
                    break;
                case /* c1.api.automations.v1.EntitlementExclusionCriteria exclusion_criteria */ 9:
                    message.exclusion = {
                        oneofKind: "exclusionCriteria",
                        exclusionCriteria: EntitlementExclusionCriteria.internalBinaryRead(reader, reader.uint32(), options, (message.exclusion as any).exclusionCriteria)
                    };
                    break;
                case /* c1.api.automations.v1.EntitlementExclusionListCel exclusion_list_cel */ 30:
                    message.exclusion = {
                        oneofKind: "exclusionListCel",
                        exclusionListCel: EntitlementExclusionListCel.internalBinaryRead(reader, reader.uint32(), options, (message.exclusion as any).exclusionListCel)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateRevokeTasksV2, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id_cel = 1; */
        if (message.user.oneofKind === "userIdCel")
            writer.tag(1, WireType.LengthDelimited).string(message.user.userIdCel);
        /* c1.api.user.v1.UserRef user_ref = 2; */
        if (message.user.oneofKind === "userRef")
            UserRef.internalBinaryWrite(message.user.userRef, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool use_subject_user = 3; */
        if (message.user.oneofKind === "useSubjectUser")
            writer.tag(3, WireType.Varint).bool(message.user.useSubjectUser);
        /* c1.api.automations.v1.EntitlementInclusionList inclusion_list = 4; */
        if (message.inclusion.oneofKind === "inclusionList")
            EntitlementInclusionList.internalBinaryWrite(message.inclusion.inclusionList, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.EntitlementInclusionAll inclusion_all = 5; */
        if (message.inclusion.oneofKind === "inclusionAll")
            EntitlementInclusionAll.internalBinaryWrite(message.inclusion.inclusionAll, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.EntitlementInclusionCriteria inclusion_criteria = 6; */
        if (message.inclusion.oneofKind === "inclusionCriteria")
            EntitlementInclusionCriteria.internalBinaryWrite(message.inclusion.inclusionCriteria, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.EntitlementExclusionNone exclusion_none = 7; */
        if (message.exclusion.oneofKind === "exclusionNone")
            EntitlementExclusionNone.internalBinaryWrite(message.exclusion.exclusionNone, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.EntitlementExclusionList exclusion_list = 8; */
        if (message.exclusion.oneofKind === "exclusionList")
            EntitlementExclusionList.internalBinaryWrite(message.exclusion.exclusionList, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.EntitlementExclusionCriteria exclusion_criteria = 9; */
        if (message.exclusion.oneofKind === "exclusionCriteria")
            EntitlementExclusionCriteria.internalBinaryWrite(message.exclusion.exclusionCriteria, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.EntitlementInclusionListCel inclusion_list_cel = 20; */
        if (message.inclusion.oneofKind === "inclusionListCel")
            EntitlementInclusionListCel.internalBinaryWrite(message.inclusion.inclusionListCel, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.EntitlementExclusionListCel exclusion_list_cel = 30; */
        if (message.exclusion.oneofKind === "exclusionListCel")
            EntitlementExclusionListCel.internalBinaryWrite(message.exclusion.exclusionListCel, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.CreateRevokeTasksV2
 */
export const CreateRevokeTasksV2 = new CreateRevokeTasksV2$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementInclusionAll$Type extends MessageType<EntitlementInclusionAll> {
    constructor() {
        super("c1.api.automations.v1.EntitlementInclusionAll", []);
    }
    create(value?: PartialMessage<EntitlementInclusionAll>): EntitlementInclusionAll {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EntitlementInclusionAll>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EntitlementInclusionAll): EntitlementInclusionAll {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EntitlementInclusionAll, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.EntitlementInclusionAll
 */
export const EntitlementInclusionAll = new EntitlementInclusionAll$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementInclusionList$Type extends MessageType<EntitlementInclusionList> {
    constructor() {
        super("c1.api.automations.v1.EntitlementInclusionList", [
            { no: 1, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<EntitlementInclusionList>): EntitlementInclusionList {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appEntitlementRefs = [];
        if (value !== undefined)
            reflectionMergePartial<EntitlementInclusionList>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EntitlementInclusionList): EntitlementInclusionList {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs */ 1:
                    message.appEntitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EntitlementInclusionList, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 1; */
        for (let i = 0; i < message.appEntitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.appEntitlementRefs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.EntitlementInclusionList
 */
export const EntitlementInclusionList = new EntitlementInclusionList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementInclusionCriteria$Type extends MessageType<EntitlementInclusionCriteria> {
    constructor() {
        super("c1.api.automations.v1.EntitlementInclusionCriteria", [
            { no: 1, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 2, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 3, name: "risk_level_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 4, name: "compliance_framework_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<EntitlementInclusionCriteria>): EntitlementInclusionCriteria {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appIds = [];
        message.resourceTypeIds = [];
        message.riskLevelIds = [];
        message.complianceFrameworkIds = [];
        if (value !== undefined)
            reflectionMergePartial<EntitlementInclusionCriteria>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EntitlementInclusionCriteria): EntitlementInclusionCriteria {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string app_ids */ 1:
                    message.appIds.push(reader.string());
                    break;
                case /* repeated string resource_type_ids */ 2:
                    message.resourceTypeIds.push(reader.string());
                    break;
                case /* repeated string risk_level_ids */ 3:
                    message.riskLevelIds.push(reader.string());
                    break;
                case /* repeated string compliance_framework_ids */ 4:
                    message.complianceFrameworkIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EntitlementInclusionCriteria, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string app_ids = 1; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.appIds[i]);
        /* repeated string resource_type_ids = 2; */
        for (let i = 0; i < message.resourceTypeIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.resourceTypeIds[i]);
        /* repeated string risk_level_ids = 3; */
        for (let i = 0; i < message.riskLevelIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.riskLevelIds[i]);
        /* repeated string compliance_framework_ids = 4; */
        for (let i = 0; i < message.complianceFrameworkIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.complianceFrameworkIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.EntitlementInclusionCriteria
 */
export const EntitlementInclusionCriteria = new EntitlementInclusionCriteria$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementInclusionListCel$Type extends MessageType<EntitlementInclusionListCel> {
    constructor() {
        super("c1.api.automations.v1.EntitlementInclusionListCel", [
            { no: 1, name: "app_entitlement_refs_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "8192" } } } }
        ]);
    }
    create(value?: PartialMessage<EntitlementInclusionListCel>): EntitlementInclusionListCel {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appEntitlementRefsCel = "";
        if (value !== undefined)
            reflectionMergePartial<EntitlementInclusionListCel>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EntitlementInclusionListCel): EntitlementInclusionListCel {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_entitlement_refs_cel */ 1:
                    message.appEntitlementRefsCel = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EntitlementInclusionListCel, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_entitlement_refs_cel = 1; */
        if (message.appEntitlementRefsCel !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appEntitlementRefsCel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.EntitlementInclusionListCel
 */
export const EntitlementInclusionListCel = new EntitlementInclusionListCel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementExclusionNone$Type extends MessageType<EntitlementExclusionNone> {
    constructor() {
        super("c1.api.automations.v1.EntitlementExclusionNone", []);
    }
    create(value?: PartialMessage<EntitlementExclusionNone>): EntitlementExclusionNone {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EntitlementExclusionNone>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EntitlementExclusionNone): EntitlementExclusionNone {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EntitlementExclusionNone, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.EntitlementExclusionNone
 */
export const EntitlementExclusionNone = new EntitlementExclusionNone$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementExclusionList$Type extends MessageType<EntitlementExclusionList> {
    constructor() {
        super("c1.api.automations.v1.EntitlementExclusionList", [
            { no: 1, name: "excluded_app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<EntitlementExclusionList>): EntitlementExclusionList {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excludedAppEntitlementRefs = [];
        if (value !== undefined)
            reflectionMergePartial<EntitlementExclusionList>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EntitlementExclusionList): EntitlementExclusionList {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementRef excluded_app_entitlement_refs */ 1:
                    message.excludedAppEntitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EntitlementExclusionList, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementRef excluded_app_entitlement_refs = 1; */
        for (let i = 0; i < message.excludedAppEntitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.excludedAppEntitlementRefs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.EntitlementExclusionList
 */
export const EntitlementExclusionList = new EntitlementExclusionList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementExclusionCriteria$Type extends MessageType<EntitlementExclusionCriteria> {
    constructor() {
        super("c1.api.automations.v1.EntitlementExclusionCriteria", [
            { no: 1, name: "excluded_app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 2, name: "excluded_resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 3, name: "excluded_risk_level_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 4, name: "excluded_compliance_framework_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<EntitlementExclusionCriteria>): EntitlementExclusionCriteria {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excludedAppIds = [];
        message.excludedResourceTypeIds = [];
        message.excludedRiskLevelIds = [];
        message.excludedComplianceFrameworkIds = [];
        if (value !== undefined)
            reflectionMergePartial<EntitlementExclusionCriteria>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EntitlementExclusionCriteria): EntitlementExclusionCriteria {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string excluded_app_ids */ 1:
                    message.excludedAppIds.push(reader.string());
                    break;
                case /* repeated string excluded_resource_type_ids */ 2:
                    message.excludedResourceTypeIds.push(reader.string());
                    break;
                case /* repeated string excluded_risk_level_ids */ 3:
                    message.excludedRiskLevelIds.push(reader.string());
                    break;
                case /* repeated string excluded_compliance_framework_ids */ 4:
                    message.excludedComplianceFrameworkIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EntitlementExclusionCriteria, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string excluded_app_ids = 1; */
        for (let i = 0; i < message.excludedAppIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.excludedAppIds[i]);
        /* repeated string excluded_resource_type_ids = 2; */
        for (let i = 0; i < message.excludedResourceTypeIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.excludedResourceTypeIds[i]);
        /* repeated string excluded_risk_level_ids = 3; */
        for (let i = 0; i < message.excludedRiskLevelIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.excludedRiskLevelIds[i]);
        /* repeated string excluded_compliance_framework_ids = 4; */
        for (let i = 0; i < message.excludedComplianceFrameworkIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.excludedComplianceFrameworkIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.EntitlementExclusionCriteria
 */
export const EntitlementExclusionCriteria = new EntitlementExclusionCriteria$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementExclusionListCel$Type extends MessageType<EntitlementExclusionListCel> {
    constructor() {
        super("c1.api.automations.v1.EntitlementExclusionListCel", [
            { no: 1, name: "excluded_app_entitlement_refs_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "8192" } } } }
        ]);
    }
    create(value?: PartialMessage<EntitlementExclusionListCel>): EntitlementExclusionListCel {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excludedAppEntitlementRefsCel = "";
        if (value !== undefined)
            reflectionMergePartial<EntitlementExclusionListCel>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EntitlementExclusionListCel): EntitlementExclusionListCel {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string excluded_app_entitlement_refs_cel */ 1:
                    message.excludedAppEntitlementRefsCel = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EntitlementExclusionListCel, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string excluded_app_entitlement_refs_cel = 1; */
        if (message.excludedAppEntitlementRefsCel !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.excludedAppEntitlementRefsCel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.EntitlementExclusionListCel
 */
export const EntitlementExclusionListCel = new EntitlementExclusionListCel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantEntitlements$Type extends MessageType<GrantEntitlements> {
    constructor() {
        super("c1.api.automations.v1.GrantEntitlements", [
            { no: 1, name: "user_id_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_ref", kind: "message", T: () => UserRef, options: { "validate.rules": { message: { required: false } } } },
            { no: 3, name: "app_entitlement_refs_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "use_subject_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "inclusion_list", kind: "message", oneof: "inclusion", T: () => GrantEntitlementInclusionList },
            { no: 11, name: "inclusion_criteria", kind: "message", oneof: "inclusion", T: () => GrantEntitlementInclusionCriteria },
            { no: 12, name: "inclusion_list_cel", kind: "message", oneof: "inclusion", T: () => GrantEntitlementInclusionListCel },
            { no: 20, name: "exclusion_none", kind: "message", oneof: "exclusion", T: () => GrantEntitlementExclusionNone },
            { no: 21, name: "exclusion_list", kind: "message", oneof: "exclusion", T: () => GrantEntitlementExclusionList },
            { no: 22, name: "exclusion_criteria", kind: "message", oneof: "exclusion", T: () => GrantEntitlementExclusionCriteria },
            { no: 23, name: "exclusion_list_cel", kind: "message", oneof: "exclusion", T: () => GrantEntitlementExclusionListCel }
        ]);
    }
    create(value?: PartialMessage<GrantEntitlements>): GrantEntitlements {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userIdCel = "";
        message.appEntitlementRefsCel = "";
        message.appEntitlementRefs = [];
        message.useSubjectUser = false;
        message.inclusion = { oneofKind: undefined };
        message.exclusion = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<GrantEntitlements>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantEntitlements): GrantEntitlements {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id_cel */ 1:
                    message.userIdCel = reader.string();
                    break;
                case /* c1.api.user.v1.UserRef user_ref */ 2:
                    message.userRef = UserRef.internalBinaryRead(reader, reader.uint32(), options, message.userRef);
                    break;
                case /* string app_entitlement_refs_cel */ 3:
                    message.appEntitlementRefsCel = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs */ 4:
                    message.appEntitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool use_subject_user */ 5:
                    message.useSubjectUser = reader.bool();
                    break;
                case /* c1.api.automations.v1.GrantEntitlementInclusionList inclusion_list */ 10:
                    message.inclusion = {
                        oneofKind: "inclusionList",
                        inclusionList: GrantEntitlementInclusionList.internalBinaryRead(reader, reader.uint32(), options, (message.inclusion as any).inclusionList)
                    };
                    break;
                case /* c1.api.automations.v1.GrantEntitlementInclusionCriteria inclusion_criteria */ 11:
                    message.inclusion = {
                        oneofKind: "inclusionCriteria",
                        inclusionCriteria: GrantEntitlementInclusionCriteria.internalBinaryRead(reader, reader.uint32(), options, (message.inclusion as any).inclusionCriteria)
                    };
                    break;
                case /* c1.api.automations.v1.GrantEntitlementInclusionListCel inclusion_list_cel */ 12:
                    message.inclusion = {
                        oneofKind: "inclusionListCel",
                        inclusionListCel: GrantEntitlementInclusionListCel.internalBinaryRead(reader, reader.uint32(), options, (message.inclusion as any).inclusionListCel)
                    };
                    break;
                case /* c1.api.automations.v1.GrantEntitlementExclusionNone exclusion_none */ 20:
                    message.exclusion = {
                        oneofKind: "exclusionNone",
                        exclusionNone: GrantEntitlementExclusionNone.internalBinaryRead(reader, reader.uint32(), options, (message.exclusion as any).exclusionNone)
                    };
                    break;
                case /* c1.api.automations.v1.GrantEntitlementExclusionList exclusion_list */ 21:
                    message.exclusion = {
                        oneofKind: "exclusionList",
                        exclusionList: GrantEntitlementExclusionList.internalBinaryRead(reader, reader.uint32(), options, (message.exclusion as any).exclusionList)
                    };
                    break;
                case /* c1.api.automations.v1.GrantEntitlementExclusionCriteria exclusion_criteria */ 22:
                    message.exclusion = {
                        oneofKind: "exclusionCriteria",
                        exclusionCriteria: GrantEntitlementExclusionCriteria.internalBinaryRead(reader, reader.uint32(), options, (message.exclusion as any).exclusionCriteria)
                    };
                    break;
                case /* c1.api.automations.v1.GrantEntitlementExclusionListCel exclusion_list_cel */ 23:
                    message.exclusion = {
                        oneofKind: "exclusionListCel",
                        exclusionListCel: GrantEntitlementExclusionListCel.internalBinaryRead(reader, reader.uint32(), options, (message.exclusion as any).exclusionListCel)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantEntitlements, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id_cel = 1; */
        if (message.userIdCel !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userIdCel);
        /* c1.api.user.v1.UserRef user_ref = 2; */
        if (message.userRef)
            UserRef.internalBinaryWrite(message.userRef, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string app_entitlement_refs_cel = 3; */
        if (message.appEntitlementRefsCel !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appEntitlementRefsCel);
        /* repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 4; */
        for (let i = 0; i < message.appEntitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.appEntitlementRefs[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool use_subject_user = 5; */
        if (message.useSubjectUser !== false)
            writer.tag(5, WireType.Varint).bool(message.useSubjectUser);
        /* c1.api.automations.v1.GrantEntitlementInclusionList inclusion_list = 10; */
        if (message.inclusion.oneofKind === "inclusionList")
            GrantEntitlementInclusionList.internalBinaryWrite(message.inclusion.inclusionList, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.GrantEntitlementInclusionCriteria inclusion_criteria = 11; */
        if (message.inclusion.oneofKind === "inclusionCriteria")
            GrantEntitlementInclusionCriteria.internalBinaryWrite(message.inclusion.inclusionCriteria, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.GrantEntitlementInclusionListCel inclusion_list_cel = 12; */
        if (message.inclusion.oneofKind === "inclusionListCel")
            GrantEntitlementInclusionListCel.internalBinaryWrite(message.inclusion.inclusionListCel, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.GrantEntitlementExclusionNone exclusion_none = 20; */
        if (message.exclusion.oneofKind === "exclusionNone")
            GrantEntitlementExclusionNone.internalBinaryWrite(message.exclusion.exclusionNone, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.GrantEntitlementExclusionList exclusion_list = 21; */
        if (message.exclusion.oneofKind === "exclusionList")
            GrantEntitlementExclusionList.internalBinaryWrite(message.exclusion.exclusionList, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.GrantEntitlementExclusionCriteria exclusion_criteria = 22; */
        if (message.exclusion.oneofKind === "exclusionCriteria")
            GrantEntitlementExclusionCriteria.internalBinaryWrite(message.exclusion.exclusionCriteria, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.GrantEntitlementExclusionListCel exclusion_list_cel = 23; */
        if (message.exclusion.oneofKind === "exclusionListCel")
            GrantEntitlementExclusionListCel.internalBinaryWrite(message.exclusion.exclusionListCel, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantEntitlements
 */
export const GrantEntitlements = new GrantEntitlements$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantEntitlementInclusionList$Type extends MessageType<GrantEntitlementInclusionList> {
    constructor() {
        super("c1.api.automations.v1.GrantEntitlementInclusionList", [
            { no: 1, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<GrantEntitlementInclusionList>): GrantEntitlementInclusionList {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appEntitlementRefs = [];
        if (value !== undefined)
            reflectionMergePartial<GrantEntitlementInclusionList>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantEntitlementInclusionList): GrantEntitlementInclusionList {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs */ 1:
                    message.appEntitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantEntitlementInclusionList, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 1; */
        for (let i = 0; i < message.appEntitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.appEntitlementRefs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantEntitlementInclusionList
 */
export const GrantEntitlementInclusionList = new GrantEntitlementInclusionList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantEntitlementInclusionCriteria$Type extends MessageType<GrantEntitlementInclusionCriteria> {
    constructor() {
        super("c1.api.automations.v1.GrantEntitlementInclusionCriteria", [
            { no: 1, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 2, name: "risk_level_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "compliance_framework_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<GrantEntitlementInclusionCriteria>): GrantEntitlementInclusionCriteria {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appIds = [];
        message.riskLevelIds = [];
        message.complianceFrameworkIds = [];
        if (value !== undefined)
            reflectionMergePartial<GrantEntitlementInclusionCriteria>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantEntitlementInclusionCriteria): GrantEntitlementInclusionCriteria {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string app_ids */ 1:
                    message.appIds.push(reader.string());
                    break;
                case /* repeated string risk_level_ids */ 2:
                    message.riskLevelIds.push(reader.string());
                    break;
                case /* repeated string compliance_framework_ids */ 3:
                    message.complianceFrameworkIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantEntitlementInclusionCriteria, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string app_ids = 1; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.appIds[i]);
        /* repeated string risk_level_ids = 2; */
        for (let i = 0; i < message.riskLevelIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.riskLevelIds[i]);
        /* repeated string compliance_framework_ids = 3; */
        for (let i = 0; i < message.complianceFrameworkIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.complianceFrameworkIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantEntitlementInclusionCriteria
 */
export const GrantEntitlementInclusionCriteria = new GrantEntitlementInclusionCriteria$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantEntitlementInclusionListCel$Type extends MessageType<GrantEntitlementInclusionListCel> {
    constructor() {
        super("c1.api.automations.v1.GrantEntitlementInclusionListCel", [
            { no: 1, name: "app_entitlement_refs_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "8192" } } } }
        ]);
    }
    create(value?: PartialMessage<GrantEntitlementInclusionListCel>): GrantEntitlementInclusionListCel {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appEntitlementRefsCel = "";
        if (value !== undefined)
            reflectionMergePartial<GrantEntitlementInclusionListCel>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantEntitlementInclusionListCel): GrantEntitlementInclusionListCel {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_entitlement_refs_cel */ 1:
                    message.appEntitlementRefsCel = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantEntitlementInclusionListCel, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_entitlement_refs_cel = 1; */
        if (message.appEntitlementRefsCel !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appEntitlementRefsCel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantEntitlementInclusionListCel
 */
export const GrantEntitlementInclusionListCel = new GrantEntitlementInclusionListCel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantEntitlementExclusionNone$Type extends MessageType<GrantEntitlementExclusionNone> {
    constructor() {
        super("c1.api.automations.v1.GrantEntitlementExclusionNone", []);
    }
    create(value?: PartialMessage<GrantEntitlementExclusionNone>): GrantEntitlementExclusionNone {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GrantEntitlementExclusionNone>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantEntitlementExclusionNone): GrantEntitlementExclusionNone {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantEntitlementExclusionNone, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantEntitlementExclusionNone
 */
export const GrantEntitlementExclusionNone = new GrantEntitlementExclusionNone$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantEntitlementExclusionList$Type extends MessageType<GrantEntitlementExclusionList> {
    constructor() {
        super("c1.api.automations.v1.GrantEntitlementExclusionList", [
            { no: 1, name: "excluded_app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<GrantEntitlementExclusionList>): GrantEntitlementExclusionList {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excludedAppEntitlementRefs = [];
        if (value !== undefined)
            reflectionMergePartial<GrantEntitlementExclusionList>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantEntitlementExclusionList): GrantEntitlementExclusionList {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementRef excluded_app_entitlement_refs */ 1:
                    message.excludedAppEntitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantEntitlementExclusionList, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementRef excluded_app_entitlement_refs = 1; */
        for (let i = 0; i < message.excludedAppEntitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.excludedAppEntitlementRefs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantEntitlementExclusionList
 */
export const GrantEntitlementExclusionList = new GrantEntitlementExclusionList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantEntitlementExclusionCriteria$Type extends MessageType<GrantEntitlementExclusionCriteria> {
    constructor() {
        super("c1.api.automations.v1.GrantEntitlementExclusionCriteria", [
            { no: 1, name: "excluded_app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 2, name: "excluded_risk_level_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "excluded_compliance_framework_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<GrantEntitlementExclusionCriteria>): GrantEntitlementExclusionCriteria {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excludedAppIds = [];
        message.excludedRiskLevelIds = [];
        message.excludedComplianceFrameworkIds = [];
        if (value !== undefined)
            reflectionMergePartial<GrantEntitlementExclusionCriteria>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantEntitlementExclusionCriteria): GrantEntitlementExclusionCriteria {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string excluded_app_ids */ 1:
                    message.excludedAppIds.push(reader.string());
                    break;
                case /* repeated string excluded_risk_level_ids */ 2:
                    message.excludedRiskLevelIds.push(reader.string());
                    break;
                case /* repeated string excluded_compliance_framework_ids */ 3:
                    message.excludedComplianceFrameworkIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantEntitlementExclusionCriteria, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string excluded_app_ids = 1; */
        for (let i = 0; i < message.excludedAppIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.excludedAppIds[i]);
        /* repeated string excluded_risk_level_ids = 2; */
        for (let i = 0; i < message.excludedRiskLevelIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.excludedRiskLevelIds[i]);
        /* repeated string excluded_compliance_framework_ids = 3; */
        for (let i = 0; i < message.excludedComplianceFrameworkIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.excludedComplianceFrameworkIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantEntitlementExclusionCriteria
 */
export const GrantEntitlementExclusionCriteria = new GrantEntitlementExclusionCriteria$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantEntitlementExclusionListCel$Type extends MessageType<GrantEntitlementExclusionListCel> {
    constructor() {
        super("c1.api.automations.v1.GrantEntitlementExclusionListCel", [
            { no: 1, name: "excluded_app_entitlement_refs_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "8192" } } } }
        ]);
    }
    create(value?: PartialMessage<GrantEntitlementExclusionListCel>): GrantEntitlementExclusionListCel {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excludedAppEntitlementRefsCel = "";
        if (value !== undefined)
            reflectionMergePartial<GrantEntitlementExclusionListCel>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantEntitlementExclusionListCel): GrantEntitlementExclusionListCel {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string excluded_app_entitlement_refs_cel */ 1:
                    message.excludedAppEntitlementRefsCel = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantEntitlementExclusionListCel, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string excluded_app_entitlement_refs_cel = 1; */
        if (message.excludedAppEntitlementRefsCel !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.excludedAppEntitlementRefsCel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantEntitlementExclusionListCel
 */
export const GrantEntitlementExclusionListCel = new GrantEntitlementExclusionListCel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveFromDelegation$Type extends MessageType<RemoveFromDelegation> {
    constructor() {
        super("c1.api.automations.v1.RemoveFromDelegation", [
            { no: 1, name: "user_id_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_ref", kind: "message", T: () => UserRef, options: { "validate.rules": { message: { required: false } } } },
            { no: 3, name: "use_subject_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "replacement_user_id_cel", kind: "scalar", oneof: "replacementUser", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "replacement_user_ref", kind: "message", oneof: "replacementUser", T: () => UserRef }
        ]);
    }
    create(value?: PartialMessage<RemoveFromDelegation>): RemoveFromDelegation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userIdCel = "";
        message.useSubjectUser = false;
        message.replacementUser = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<RemoveFromDelegation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveFromDelegation): RemoveFromDelegation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id_cel */ 1:
                    message.userIdCel = reader.string();
                    break;
                case /* c1.api.user.v1.UserRef user_ref */ 2:
                    message.userRef = UserRef.internalBinaryRead(reader, reader.uint32(), options, message.userRef);
                    break;
                case /* bool use_subject_user */ 3:
                    message.useSubjectUser = reader.bool();
                    break;
                case /* string replacement_user_id_cel */ 4:
                    message.replacementUser = {
                        oneofKind: "replacementUserIdCel",
                        replacementUserIdCel: reader.string()
                    };
                    break;
                case /* c1.api.user.v1.UserRef replacement_user_ref */ 5:
                    message.replacementUser = {
                        oneofKind: "replacementUserRef",
                        replacementUserRef: UserRef.internalBinaryRead(reader, reader.uint32(), options, (message.replacementUser as any).replacementUserRef)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveFromDelegation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id_cel = 1; */
        if (message.userIdCel !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userIdCel);
        /* c1.api.user.v1.UserRef user_ref = 2; */
        if (message.userRef)
            UserRef.internalBinaryWrite(message.userRef, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool use_subject_user = 3; */
        if (message.useSubjectUser !== false)
            writer.tag(3, WireType.Varint).bool(message.useSubjectUser);
        /* string replacement_user_id_cel = 4; */
        if (message.replacementUser.oneofKind === "replacementUserIdCel")
            writer.tag(4, WireType.LengthDelimited).string(message.replacementUser.replacementUserIdCel);
        /* c1.api.user.v1.UserRef replacement_user_ref = 5; */
        if (message.replacementUser.oneofKind === "replacementUserRef")
            UserRef.internalBinaryWrite(message.replacementUser.replacementUserRef, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.RemoveFromDelegation
 */
export const RemoveFromDelegation = new RemoveFromDelegation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RunAutomation$Type extends MessageType<RunAutomation> {
    constructor() {
        super("c1.api.automations.v1.RunAutomation", [
            { no: 1, name: "automation_template_ref", kind: "message", oneof: "automationTemplate", T: () => AutomationTemplateRef },
            { no: 2, name: "automation_template_id_cel", kind: "scalar", oneof: "automationTemplate", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "context", kind: "message", T: () => AutomationContext }
        ]);
    }
    create(value?: PartialMessage<RunAutomation>): RunAutomation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.automationTemplate = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<RunAutomation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RunAutomation): RunAutomation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.automations.v1.AutomationTemplateRef automation_template_ref */ 1:
                    message.automationTemplate = {
                        oneofKind: "automationTemplateRef",
                        automationTemplateRef: AutomationTemplateRef.internalBinaryRead(reader, reader.uint32(), options, (message.automationTemplate as any).automationTemplateRef)
                    };
                    break;
                case /* string automation_template_id_cel */ 2:
                    message.automationTemplate = {
                        oneofKind: "automationTemplateIdCel",
                        automationTemplateIdCel: reader.string()
                    };
                    break;
                case /* c1.api.automations.v1.AutomationContext context */ 3:
                    message.context = AutomationContext.internalBinaryRead(reader, reader.uint32(), options, message.context);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RunAutomation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.automations.v1.AutomationTemplateRef automation_template_ref = 1; */
        if (message.automationTemplate.oneofKind === "automationTemplateRef")
            AutomationTemplateRef.internalBinaryWrite(message.automationTemplate.automationTemplateRef, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string automation_template_id_cel = 2; */
        if (message.automationTemplate.oneofKind === "automationTemplateIdCel")
            writer.tag(2, WireType.LengthDelimited).string(message.automationTemplate.automationTemplateIdCel);
        /* c1.api.automations.v1.AutomationContext context = 3; */
        if (message.context)
            AutomationContext.internalBinaryWrite(message.context, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.RunAutomation
 */
export const RunAutomation = new RunAutomation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUser$Type extends MessageType<UpdateUser> {
    constructor() {
        super("c1.api.automations.v1.UpdateUser", [
            { no: 5, name: "user_id_cel", kind: "scalar", oneof: "user", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "user_ref", kind: "message", oneof: "user", T: () => UserRef },
            { no: 7, name: "user_status_enum", kind: "enum", oneof: "userStatus", T: () => ["c1.api.user.v1.UserStatus", UserStatus] },
            { no: 8, name: "user_status_cel", kind: "scalar", oneof: "userStatus", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "use_subject_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateUser>): UpdateUser {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.user = { oneofKind: undefined };
        message.userStatus = { oneofKind: undefined };
        message.useSubjectUser = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateUser>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateUser): UpdateUser {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id_cel */ 5:
                    message.user = {
                        oneofKind: "userIdCel",
                        userIdCel: reader.string()
                    };
                    break;
                case /* c1.api.user.v1.UserRef user_ref */ 6:
                    message.user = {
                        oneofKind: "userRef",
                        userRef: UserRef.internalBinaryRead(reader, reader.uint32(), options, (message.user as any).userRef)
                    };
                    break;
                case /* c1.api.user.v1.UserStatus user_status_enum */ 7:
                    message.userStatus = {
                        oneofKind: "userStatusEnum",
                        userStatusEnum: reader.int32()
                    };
                    break;
                case /* string user_status_cel */ 8:
                    message.userStatus = {
                        oneofKind: "userStatusCel",
                        userStatusCel: reader.string()
                    };
                    break;
                case /* bool use_subject_user */ 9:
                    message.useSubjectUser = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateUser, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id_cel = 5; */
        if (message.user.oneofKind === "userIdCel")
            writer.tag(5, WireType.LengthDelimited).string(message.user.userIdCel);
        /* c1.api.user.v1.UserRef user_ref = 6; */
        if (message.user.oneofKind === "userRef")
            UserRef.internalBinaryWrite(message.user.userRef, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.UserStatus user_status_enum = 7; */
        if (message.userStatus.oneofKind === "userStatusEnum")
            writer.tag(7, WireType.Varint).int32(message.userStatus.userStatusEnum);
        /* string user_status_cel = 8; */
        if (message.userStatus.oneofKind === "userStatusCel")
            writer.tag(8, WireType.LengthDelimited).string(message.userStatus.userStatusCel);
        /* bool use_subject_user = 9; */
        if (message.useSubjectUser !== false)
            writer.tag(9, WireType.Varint).bool(message.useSubjectUser);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.UpdateUser
 */
export const UpdateUser = new UpdateUser$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CloseAction$Type extends MessageType<CloseAction> {
    constructor() {
        super("c1.api.automations.v1.CloseAction", [
            { no: 1, name: "user_id_cel", kind: "scalar", oneof: "userIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_ref", kind: "message", oneof: "userIdentifier", T: () => UserRef },
            { no: 3, name: "use_subject_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CloseAction>): CloseAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userIdentifier = { oneofKind: undefined };
        message.useSubjectUser = false;
        if (value !== undefined)
            reflectionMergePartial<CloseAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CloseAction): CloseAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id_cel */ 1:
                    message.userIdentifier = {
                        oneofKind: "userIdCel",
                        userIdCel: reader.string()
                    };
                    break;
                case /* c1.api.user.v1.UserRef user_ref */ 2:
                    message.userIdentifier = {
                        oneofKind: "userRef",
                        userRef: UserRef.internalBinaryRead(reader, reader.uint32(), options, (message.userIdentifier as any).userRef)
                    };
                    break;
                case /* bool use_subject_user */ 3:
                    message.useSubjectUser = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CloseAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id_cel = 1; */
        if (message.userIdentifier.oneofKind === "userIdCel")
            writer.tag(1, WireType.LengthDelimited).string(message.userIdentifier.userIdCel);
        /* c1.api.user.v1.UserRef user_ref = 2; */
        if (message.userIdentifier.oneofKind === "userRef")
            UserRef.internalBinaryWrite(message.userIdentifier.userRef, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool use_subject_user = 3; */
        if (message.useSubjectUser !== false)
            writer.tag(3, WireType.Varint).bool(message.useSubjectUser);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.CloseAction
 */
export const CloseAction = new CloseAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReassignAction$Type extends MessageType<ReassignAction> {
    constructor() {
        super("c1.api.automations.v1.ReassignAction", [
            { no: 1, name: "assignee_user_id_cel", kind: "scalar", oneof: "assigneeUserIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "assignee_user_ref", kind: "message", oneof: "assigneeUserIdentifier", T: () => UserRef },
            { no: 3, name: "subject_user_id_cel", kind: "scalar", oneof: "subjectUserIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "subject_user_ref", kind: "message", oneof: "subjectUserIdentifier", T: () => UserRef },
            { no: 5, name: "use_subject_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ReassignAction>): ReassignAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.assigneeUserIdentifier = { oneofKind: undefined };
        message.subjectUserIdentifier = { oneofKind: undefined };
        message.useSubjectUser = false;
        if (value !== undefined)
            reflectionMergePartial<ReassignAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReassignAction): ReassignAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string assignee_user_id_cel */ 1:
                    message.assigneeUserIdentifier = {
                        oneofKind: "assigneeUserIdCel",
                        assigneeUserIdCel: reader.string()
                    };
                    break;
                case /* c1.api.user.v1.UserRef assignee_user_ref */ 2:
                    message.assigneeUserIdentifier = {
                        oneofKind: "assigneeUserRef",
                        assigneeUserRef: UserRef.internalBinaryRead(reader, reader.uint32(), options, (message.assigneeUserIdentifier as any).assigneeUserRef)
                    };
                    break;
                case /* string subject_user_id_cel */ 3:
                    message.subjectUserIdentifier = {
                        oneofKind: "subjectUserIdCel",
                        subjectUserIdCel: reader.string()
                    };
                    break;
                case /* c1.api.user.v1.UserRef subject_user_ref */ 4:
                    message.subjectUserIdentifier = {
                        oneofKind: "subjectUserRef",
                        subjectUserRef: UserRef.internalBinaryRead(reader, reader.uint32(), options, (message.subjectUserIdentifier as any).subjectUserRef)
                    };
                    break;
                case /* bool use_subject_user */ 5:
                    message.useSubjectUser = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReassignAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string assignee_user_id_cel = 1; */
        if (message.assigneeUserIdentifier.oneofKind === "assigneeUserIdCel")
            writer.tag(1, WireType.LengthDelimited).string(message.assigneeUserIdentifier.assigneeUserIdCel);
        /* c1.api.user.v1.UserRef assignee_user_ref = 2; */
        if (message.assigneeUserIdentifier.oneofKind === "assigneeUserRef")
            UserRef.internalBinaryWrite(message.assigneeUserIdentifier.assigneeUserRef, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string subject_user_id_cel = 3; */
        if (message.subjectUserIdentifier.oneofKind === "subjectUserIdCel")
            writer.tag(3, WireType.LengthDelimited).string(message.subjectUserIdentifier.subjectUserIdCel);
        /* c1.api.user.v1.UserRef subject_user_ref = 4; */
        if (message.subjectUserIdentifier.oneofKind === "subjectUserRef")
            UserRef.internalBinaryWrite(message.subjectUserIdentifier.subjectUserRef, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool use_subject_user = 5; */
        if (message.useSubjectUser !== false)
            writer.tag(5, WireType.Varint).bool(message.useSubjectUser);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ReassignAction
 */
export const ReassignAction = new ReassignAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAction$Type extends MessageType<TaskAction> {
    constructor() {
        super("c1.api.automations.v1.TaskAction", [
            { no: 1, name: "close", kind: "message", oneof: "action", T: () => CloseAction },
            { no: 2, name: "reassign", kind: "message", oneof: "action", T: () => ReassignAction },
            { no: 3, name: "task_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.automations.v1.TaskType", TaskType, "TASK_TYPE_"] },
            { no: 4, name: "task_user_relation", kind: "enum", T: () => ["c1.api.automations.v1.TaskUserRelation", TaskUserRelation, "TASK_USER_RELATION_"] }
        ]);
    }
    create(value?: PartialMessage<TaskAction>): TaskAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.action = { oneofKind: undefined };
        message.taskTypes = [];
        message.taskUserRelation = 0;
        if (value !== undefined)
            reflectionMergePartial<TaskAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAction): TaskAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.automations.v1.CloseAction close */ 1:
                    message.action = {
                        oneofKind: "close",
                        close: CloseAction.internalBinaryRead(reader, reader.uint32(), options, (message.action as any).close)
                    };
                    break;
                case /* c1.api.automations.v1.ReassignAction reassign */ 2:
                    message.action = {
                        oneofKind: "reassign",
                        reassign: ReassignAction.internalBinaryRead(reader, reader.uint32(), options, (message.action as any).reassign)
                    };
                    break;
                case /* repeated c1.api.automations.v1.TaskType task_types */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.taskTypes.push(reader.int32());
                    else
                        message.taskTypes.push(reader.int32());
                    break;
                case /* c1.api.automations.v1.TaskUserRelation task_user_relation */ 4:
                    message.taskUserRelation = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.automations.v1.CloseAction close = 1; */
        if (message.action.oneofKind === "close")
            CloseAction.internalBinaryWrite(message.action.close, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.ReassignAction reassign = 2; */
        if (message.action.oneofKind === "reassign")
            ReassignAction.internalBinaryWrite(message.action.reassign, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.automations.v1.TaskType task_types = 3; */
        if (message.taskTypes.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.taskTypes.length; i++)
                writer.int32(message.taskTypes[i]);
            writer.join();
        }
        /* c1.api.automations.v1.TaskUserRelation task_user_relation = 4; */
        if (message.taskUserRelation !== 0)
            writer.tag(4, WireType.Varint).int32(message.taskUserRelation);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.TaskAction
 */
export const TaskAction = new TaskAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationContext$Type extends MessageType<AutomationContext> {
    constructor() {
        super("c1.api.automations.v1.AutomationContext", [
            { no: 1, name: "context", kind: "message", T: () => Struct }
        ]);
    }
    create(value?: PartialMessage<AutomationContext>): AutomationContext {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AutomationContext>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AutomationContext): AutomationContext {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Struct context */ 1:
                    message.context = Struct.internalBinaryRead(reader, reader.uint32(), options, message.context);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AutomationContext, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Struct context = 1; */
        if (message.context)
            Struct.internalBinaryWrite(message.context, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationContext
 */
export const AutomationContext = new AutomationContext$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Webhook$Type extends MessageType<Webhook> {
    constructor() {
        super("c1.api.automations.v1.Webhook", [
            { no: 1, name: "webhook_id", kind: "scalar", oneof: "webhookIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "webhook_id_cel", kind: "scalar", oneof: "webhookIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "payload", kind: "message", T: () => Struct }
        ]);
    }
    create(value?: PartialMessage<Webhook>): Webhook {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.webhookIdentifier = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<Webhook>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Webhook): Webhook {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string webhook_id */ 1:
                    message.webhookIdentifier = {
                        oneofKind: "webhookId",
                        webhookId: reader.string()
                    };
                    break;
                case /* string webhook_id_cel */ 2:
                    message.webhookIdentifier = {
                        oneofKind: "webhookIdCel",
                        webhookIdCel: reader.string()
                    };
                    break;
                case /* google.protobuf.Struct payload */ 3:
                    message.payload = Struct.internalBinaryRead(reader, reader.uint32(), options, message.payload);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Webhook, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string webhook_id = 1; */
        if (message.webhookIdentifier.oneofKind === "webhookId")
            writer.tag(1, WireType.LengthDelimited).string(message.webhookIdentifier.webhookId);
        /* string webhook_id_cel = 2; */
        if (message.webhookIdentifier.oneofKind === "webhookIdCel")
            writer.tag(2, WireType.LengthDelimited).string(message.webhookIdentifier.webhookIdCel);
        /* google.protobuf.Struct payload = 3; */
        if (message.payload)
            Struct.internalBinaryWrite(message.payload, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.Webhook
 */
export const Webhook = new Webhook$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAction$Type extends MessageType<ConnectorAction> {
    constructor() {
        super("c1.api.automations.v1.ConnectorAction", [
            { no: 1, name: "connector_ref", kind: "message", oneof: "connectorIdentifier", T: () => ConnectorRef },
            { no: 2, name: "action_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "args_template", kind: "message", T: () => Struct },
            { no: 4, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorAction>): ConnectorAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.connectorIdentifier = { oneofKind: undefined };
        message.actionName = "";
        message.resourceTypeId = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorAction): ConnectorAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.ConnectorRef connector_ref */ 1:
                    message.connectorIdentifier = {
                        oneofKind: "connectorRef",
                        connectorRef: ConnectorRef.internalBinaryRead(reader, reader.uint32(), options, (message.connectorIdentifier as any).connectorRef)
                    };
                    break;
                case /* string action_name */ 2:
                    message.actionName = reader.string();
                    break;
                case /* google.protobuf.Struct args_template */ 3:
                    message.argsTemplate = Struct.internalBinaryRead(reader, reader.uint32(), options, message.argsTemplate);
                    break;
                case /* string resource_type_id */ 4:
                    message.resourceTypeId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.ConnectorRef connector_ref = 1; */
        if (message.connectorIdentifier.oneofKind === "connectorRef")
            ConnectorRef.internalBinaryWrite(message.connectorIdentifier.connectorRef, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string action_name = 2; */
        if (message.actionName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.actionName);
        /* google.protobuf.Struct args_template = 3; */
        if (message.argsTemplate)
            Struct.internalBinaryWrite(message.argsTemplate, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string resource_type_id = 4; */
        if (message.resourceTypeId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.resourceTypeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ConnectorAction
 */
export const ConnectorAction = new ConnectorAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountLifecycleAction$Type extends MessageType<AccountLifecycleAction> {
    constructor() {
        super("c1.api.automations.v1.AccountLifecycleAction", [
            { no: 1, name: "connector_ref", kind: "message", T: () => ConnectorRef },
            { no: 2, name: "action_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "account_ref", kind: "message", oneof: "accountIdentifier", T: () => AccountRef },
            { no: 101, name: "account_in_context", kind: "message", oneof: "accountIdentifier", T: () => AccountInContext }
        ]);
    }
    create(value?: PartialMessage<AccountLifecycleAction>): AccountLifecycleAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.actionName = "";
        message.accountIdentifier = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AccountLifecycleAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccountLifecycleAction): AccountLifecycleAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.ConnectorRef connector_ref */ 1:
                    message.connectorRef = ConnectorRef.internalBinaryRead(reader, reader.uint32(), options, message.connectorRef);
                    break;
                case /* string action_name */ 2:
                    message.actionName = reader.string();
                    break;
                case /* c1.api.automations.v1.AccountRef account_ref */ 100:
                    message.accountIdentifier = {
                        oneofKind: "accountRef",
                        accountRef: AccountRef.internalBinaryRead(reader, reader.uint32(), options, (message.accountIdentifier as any).accountRef)
                    };
                    break;
                case /* c1.api.automations.v1.AccountInContext account_in_context */ 101:
                    message.accountIdentifier = {
                        oneofKind: "accountInContext",
                        accountInContext: AccountInContext.internalBinaryRead(reader, reader.uint32(), options, (message.accountIdentifier as any).accountInContext)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccountLifecycleAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.ConnectorRef connector_ref = 1; */
        if (message.connectorRef)
            ConnectorRef.internalBinaryWrite(message.connectorRef, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string action_name = 2; */
        if (message.actionName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.actionName);
        /* c1.api.automations.v1.AccountRef account_ref = 100; */
        if (message.accountIdentifier.oneofKind === "accountRef")
            AccountRef.internalBinaryWrite(message.accountIdentifier.accountRef, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.AccountInContext account_in_context = 101; */
        if (message.accountIdentifier.oneofKind === "accountInContext")
            AccountInContext.internalBinaryWrite(message.accountIdentifier.accountInContext, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AccountLifecycleAction
 */
export const AccountLifecycleAction = new AccountLifecycleAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeneratePassword$Type extends MessageType<GeneratePassword> {
    constructor() {
        super("c1.api.automations.v1.GeneratePassword", []);
    }
    create(value?: PartialMessage<GeneratePassword>): GeneratePassword {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GeneratePassword>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GeneratePassword): GeneratePassword {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GeneratePassword, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GeneratePassword
 */
export const GeneratePassword = new GeneratePassword$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EvaluateExpressions$Type extends MessageType<EvaluateExpressions> {
    constructor() {
        super("c1.api.automations.v1.EvaluateExpressions", [
            { no: 1, name: "expressions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Expression }
        ]);
    }
    create(value?: PartialMessage<EvaluateExpressions>): EvaluateExpressions {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expressions = [];
        if (value !== undefined)
            reflectionMergePartial<EvaluateExpressions>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EvaluateExpressions): EvaluateExpressions {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.automations.v1.Expression expressions */ 1:
                    message.expressions.push(Expression.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EvaluateExpressions, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.automations.v1.Expression expressions = 1; */
        for (let i = 0; i < message.expressions.length; i++)
            Expression.internalBinaryWrite(message.expressions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.EvaluateExpressions
 */
export const EvaluateExpressions = new EvaluateExpressions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Expression$Type extends MessageType<Expression> {
    constructor() {
        super("c1.api.automations.v1.Expression", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "expression_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "is_secret", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Expression>): Expression {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.key = "";
        message.expressionCel = "";
        message.isSecret = false;
        if (value !== undefined)
            reflectionMergePartial<Expression>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Expression): Expression {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                case /* string expression_cel */ 2:
                    message.expressionCel = reader.string();
                    break;
                case /* bool is_secret */ 3:
                    message.isSecret = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Expression, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        /* string expression_cel = 2; */
        if (message.expressionCel !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.expressionCel);
        /* bool is_secret = 3; */
        if (message.isSecret !== false)
            writer.tag(3, WireType.Varint).bool(message.isSecret);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.Expression
 */
export const Expression = new Expression$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountInContext$Type extends MessageType<AccountInContext> {
    constructor() {
        super("c1.api.automations.v1.AccountInContext", []);
    }
    create(value?: PartialMessage<AccountInContext>): AccountInContext {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccountInContext>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccountInContext): AccountInContext {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccountInContext, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AccountInContext
 */
export const AccountInContext = new AccountInContext$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountRef$Type extends MessageType<AccountRef> {
    constructor() {
        super("c1.api.automations.v1.AccountRef", [
            { no: 1, name: "account_id_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccountRef>): AccountRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountIdCel = "";
        if (value !== undefined)
            reflectionMergePartial<AccountRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccountRef): AccountRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string account_id_cel */ 1:
                    message.accountIdCel = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccountRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string account_id_cel = 1; */
        if (message.accountIdCel !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accountIdCel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AccountRef
 */
export const AccountRef = new AccountRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCreateAccount$Type extends MessageType<ConnectorCreateAccount> {
    constructor() {
        super("c1.api.automations.v1.ConnectorCreateAccount", [
            { no: 1, name: "connector_ref", kind: "message", T: () => ConnectorRef },
            { no: 2, name: "user_id_cel", kind: "scalar", oneof: "createAccountArguments", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_properties", kind: "message", oneof: "createAccountArguments", T: () => UserProperties }
        ]);
    }
    create(value?: PartialMessage<ConnectorCreateAccount>): ConnectorCreateAccount {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.createAccountArguments = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<ConnectorCreateAccount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorCreateAccount): ConnectorCreateAccount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.ConnectorRef connector_ref */ 1:
                    message.connectorRef = ConnectorRef.internalBinaryRead(reader, reader.uint32(), options, message.connectorRef);
                    break;
                case /* string user_id_cel */ 2:
                    message.createAccountArguments = {
                        oneofKind: "userIdCel",
                        userIdCel: reader.string()
                    };
                    break;
                case /* c1.api.automations.v1.UserProperties user_properties */ 3:
                    message.createAccountArguments = {
                        oneofKind: "userProperties",
                        userProperties: UserProperties.internalBinaryRead(reader, reader.uint32(), options, (message.createAccountArguments as any).userProperties)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorCreateAccount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.ConnectorRef connector_ref = 1; */
        if (message.connectorRef)
            ConnectorRef.internalBinaryWrite(message.connectorRef, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string user_id_cel = 2; */
        if (message.createAccountArguments.oneofKind === "userIdCel")
            writer.tag(2, WireType.LengthDelimited).string(message.createAccountArguments.userIdCel);
        /* c1.api.automations.v1.UserProperties user_properties = 3; */
        if (message.createAccountArguments.oneofKind === "userProperties")
            UserProperties.internalBinaryWrite(message.createAccountArguments.userProperties, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ConnectorCreateAccount
 */
export const ConnectorCreateAccount = new ConnectorCreateAccount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserProperties$Type extends MessageType<UserProperties> {
    constructor() {
        super("c1.api.automations.v1.UserProperties", [
            { no: 1, name: "display_name_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "username_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "profile_attribute_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserProperties>): UserProperties {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayNameCel = "";
        message.emailCel = "";
        message.usernameCel = "";
        message.profileAttributeCel = "";
        if (value !== undefined)
            reflectionMergePartial<UserProperties>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserProperties): UserProperties {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name_cel */ 1:
                    message.displayNameCel = reader.string();
                    break;
                case /* string email_cel */ 2:
                    message.emailCel = reader.string();
                    break;
                case /* string username_cel */ 3:
                    message.usernameCel = reader.string();
                    break;
                case /* string profile_attribute_cel */ 4:
                    message.profileAttributeCel = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserProperties, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name_cel = 1; */
        if (message.displayNameCel !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayNameCel);
        /* string email_cel = 2; */
        if (message.emailCel !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.emailCel);
        /* string username_cel = 3; */
        if (message.usernameCel !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.usernameCel);
        /* string profile_attribute_cel = 4; */
        if (message.profileAttributeCel !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.profileAttributeCel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.UserProperties
 */
export const UserProperties = new UserProperties$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationTrigger$Type extends MessageType<AutomationTrigger> {
    constructor() {
        super("c1.api.automations.v1.AutomationTrigger", [
            { no: 101, name: "manual", kind: "message", oneof: "kind", T: () => ManualAutomationTrigger },
            { no: 102, name: "user_profile_change", kind: "message", oneof: "kind", T: () => UserProfileChangeTrigger },
            { no: 103, name: "app_user_created", kind: "message", oneof: "kind", T: () => AppUserCreatedTrigger },
            { no: 104, name: "app_user_updated", kind: "message", oneof: "kind", T: () => AppUserUpdatedTrigger },
            { no: 105, name: "usage_based_revocation", kind: "message", oneof: "kind", T: () => UsageBasedRevocationTrigger },
            { no: 106, name: "user_created", kind: "message", oneof: "kind", T: () => UserCreatedTrigger },
            { no: 107, name: "grant_found", kind: "message", oneof: "kind", T: () => GrantFoundTrigger },
            { no: 108, name: "grant_deleted", kind: "message", oneof: "kind", T: () => GrantDeletedTrigger },
            { no: 109, name: "webhook", kind: "message", oneof: "kind", T: () => WebhookAutomationTrigger },
            { no: 110, name: "schedule", kind: "message", oneof: "kind", T: () => ScheduleTrigger },
            { no: 111, name: "form", kind: "message", oneof: "kind", T: () => FormTrigger },
            { no: 112, name: "schedule_app_user", kind: "message", oneof: "kind", T: () => ScheduleTriggerAppUser },
            { no: 113, name: "access_conflict", kind: "message", oneof: "kind", T: () => AccessConflictTrigger }
        ]);
    }
    create(value?: PartialMessage<AutomationTrigger>): AutomationTrigger {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.kind = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AutomationTrigger>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AutomationTrigger): AutomationTrigger {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.automations.v1.ManualAutomationTrigger manual */ 101:
                    message.kind = {
                        oneofKind: "manual",
                        manual: ManualAutomationTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).manual)
                    };
                    break;
                case /* c1.api.automations.v1.UserProfileChangeTrigger user_profile_change */ 102:
                    message.kind = {
                        oneofKind: "userProfileChange",
                        userProfileChange: UserProfileChangeTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).userProfileChange)
                    };
                    break;
                case /* c1.api.automations.v1.AppUserCreatedTrigger app_user_created */ 103:
                    message.kind = {
                        oneofKind: "appUserCreated",
                        appUserCreated: AppUserCreatedTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).appUserCreated)
                    };
                    break;
                case /* c1.api.automations.v1.AppUserUpdatedTrigger app_user_updated */ 104:
                    message.kind = {
                        oneofKind: "appUserUpdated",
                        appUserUpdated: AppUserUpdatedTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).appUserUpdated)
                    };
                    break;
                case /* c1.api.automations.v1.UsageBasedRevocationTrigger usage_based_revocation */ 105:
                    message.kind = {
                        oneofKind: "usageBasedRevocation",
                        usageBasedRevocation: UsageBasedRevocationTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).usageBasedRevocation)
                    };
                    break;
                case /* c1.api.automations.v1.UserCreatedTrigger user_created */ 106:
                    message.kind = {
                        oneofKind: "userCreated",
                        userCreated: UserCreatedTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).userCreated)
                    };
                    break;
                case /* c1.api.automations.v1.GrantFoundTrigger grant_found */ 107:
                    message.kind = {
                        oneofKind: "grantFound",
                        grantFound: GrantFoundTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).grantFound)
                    };
                    break;
                case /* c1.api.automations.v1.GrantDeletedTrigger grant_deleted */ 108:
                    message.kind = {
                        oneofKind: "grantDeleted",
                        grantDeleted: GrantDeletedTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).grantDeleted)
                    };
                    break;
                case /* c1.api.automations.v1.WebhookAutomationTrigger webhook */ 109:
                    message.kind = {
                        oneofKind: "webhook",
                        webhook: WebhookAutomationTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).webhook)
                    };
                    break;
                case /* c1.api.automations.v1.ScheduleTrigger schedule */ 110:
                    message.kind = {
                        oneofKind: "schedule",
                        schedule: ScheduleTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).schedule)
                    };
                    break;
                case /* c1.api.automations.v1.FormTrigger form */ 111:
                    message.kind = {
                        oneofKind: "form",
                        form: FormTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).form)
                    };
                    break;
                case /* c1.api.automations.v1.ScheduleTriggerAppUser schedule_app_user */ 112:
                    message.kind = {
                        oneofKind: "scheduleAppUser",
                        scheduleAppUser: ScheduleTriggerAppUser.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).scheduleAppUser)
                    };
                    break;
                case /* c1.api.automations.v1.AccessConflictTrigger access_conflict */ 113:
                    message.kind = {
                        oneofKind: "accessConflict",
                        accessConflict: AccessConflictTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).accessConflict)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AutomationTrigger, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.automations.v1.ManualAutomationTrigger manual = 101; */
        if (message.kind.oneofKind === "manual")
            ManualAutomationTrigger.internalBinaryWrite(message.kind.manual, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.UserProfileChangeTrigger user_profile_change = 102; */
        if (message.kind.oneofKind === "userProfileChange")
            UserProfileChangeTrigger.internalBinaryWrite(message.kind.userProfileChange, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.AppUserCreatedTrigger app_user_created = 103; */
        if (message.kind.oneofKind === "appUserCreated")
            AppUserCreatedTrigger.internalBinaryWrite(message.kind.appUserCreated, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.AppUserUpdatedTrigger app_user_updated = 104; */
        if (message.kind.oneofKind === "appUserUpdated")
            AppUserUpdatedTrigger.internalBinaryWrite(message.kind.appUserUpdated, writer.tag(104, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.UsageBasedRevocationTrigger usage_based_revocation = 105; */
        if (message.kind.oneofKind === "usageBasedRevocation")
            UsageBasedRevocationTrigger.internalBinaryWrite(message.kind.usageBasedRevocation, writer.tag(105, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.UserCreatedTrigger user_created = 106; */
        if (message.kind.oneofKind === "userCreated")
            UserCreatedTrigger.internalBinaryWrite(message.kind.userCreated, writer.tag(106, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.GrantFoundTrigger grant_found = 107; */
        if (message.kind.oneofKind === "grantFound")
            GrantFoundTrigger.internalBinaryWrite(message.kind.grantFound, writer.tag(107, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.GrantDeletedTrigger grant_deleted = 108; */
        if (message.kind.oneofKind === "grantDeleted")
            GrantDeletedTrigger.internalBinaryWrite(message.kind.grantDeleted, writer.tag(108, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.WebhookAutomationTrigger webhook = 109; */
        if (message.kind.oneofKind === "webhook")
            WebhookAutomationTrigger.internalBinaryWrite(message.kind.webhook, writer.tag(109, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.ScheduleTrigger schedule = 110; */
        if (message.kind.oneofKind === "schedule")
            ScheduleTrigger.internalBinaryWrite(message.kind.schedule, writer.tag(110, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.FormTrigger form = 111; */
        if (message.kind.oneofKind === "form")
            FormTrigger.internalBinaryWrite(message.kind.form, writer.tag(111, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.ScheduleTriggerAppUser schedule_app_user = 112; */
        if (message.kind.oneofKind === "scheduleAppUser")
            ScheduleTriggerAppUser.internalBinaryWrite(message.kind.scheduleAppUser, writer.tag(112, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.AccessConflictTrigger access_conflict = 113; */
        if (message.kind.oneofKind === "accessConflict")
            AccessConflictTrigger.internalBinaryWrite(message.kind.accessConflict, writer.tag(113, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationTrigger
 */
export const AutomationTrigger = new AutomationTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ManualAutomationTrigger$Type extends MessageType<ManualAutomationTrigger> {
    constructor() {
        super("c1.api.automations.v1.ManualAutomationTrigger", []);
    }
    create(value?: PartialMessage<ManualAutomationTrigger>): ManualAutomationTrigger {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ManualAutomationTrigger>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ManualAutomationTrigger): ManualAutomationTrigger {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ManualAutomationTrigger, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ManualAutomationTrigger
 */
export const ManualAutomationTrigger = new ManualAutomationTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserProfileChangeTrigger$Type extends MessageType<UserProfileChangeTrigger> {
    constructor() {
        super("c1.api.automations.v1.UserProfileChangeTrigger", [
            { no: 3, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserProfileChangeTrigger>): UserProfileChangeTrigger {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.condition = "";
        if (value !== undefined)
            reflectionMergePartial<UserProfileChangeTrigger>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserProfileChangeTrigger): UserProfileChangeTrigger {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string condition */ 3:
                    message.condition = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserProfileChangeTrigger, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string condition = 3; */
        if (message.condition !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.condition);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.UserProfileChangeTrigger
 */
export const UserProfileChangeTrigger = new UserProfileChangeTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserCreatedTrigger$Type extends MessageType<UserCreatedTrigger> {
    constructor() {
        super("c1.api.automations.v1.UserCreatedTrigger", [
            { no: 1, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserCreatedTrigger>): UserCreatedTrigger {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.condition = "";
        if (value !== undefined)
            reflectionMergePartial<UserCreatedTrigger>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserCreatedTrigger): UserCreatedTrigger {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string condition */ 1:
                    message.condition = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserCreatedTrigger, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string condition = 1; */
        if (message.condition !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.condition);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.UserCreatedTrigger
 */
export const UserCreatedTrigger = new UserCreatedTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserCreatedTrigger$Type extends MessageType<AppUserCreatedTrigger> {
    constructor() {
        super("c1.api.automations.v1.AppUserCreatedTrigger", [
            { no: 1, name: "app_id", kind: "scalar", oneof: "appIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id_cel", kind: "scalar", oneof: "appIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppUserCreatedTrigger>): AppUserCreatedTrigger {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appIdentifier = { oneofKind: undefined };
        message.condition = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserCreatedTrigger>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserCreatedTrigger): AppUserCreatedTrigger {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appIdentifier = {
                        oneofKind: "appId",
                        appId: reader.string()
                    };
                    break;
                case /* string app_id_cel */ 2:
                    message.appIdentifier = {
                        oneofKind: "appIdCel",
                        appIdCel: reader.string()
                    };
                    break;
                case /* string condition */ 3:
                    message.condition = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserCreatedTrigger, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appIdentifier.oneofKind === "appId")
            writer.tag(1, WireType.LengthDelimited).string(message.appIdentifier.appId);
        /* string app_id_cel = 2; */
        if (message.appIdentifier.oneofKind === "appIdCel")
            writer.tag(2, WireType.LengthDelimited).string(message.appIdentifier.appIdCel);
        /* string condition = 3; */
        if (message.condition !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.condition);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AppUserCreatedTrigger
 */
export const AppUserCreatedTrigger = new AppUserCreatedTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserUpdatedTrigger$Type extends MessageType<AppUserUpdatedTrigger> {
    constructor() {
        super("c1.api.automations.v1.AppUserUpdatedTrigger", [
            { no: 1, name: "app_id", kind: "scalar", oneof: "appIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id_cel", kind: "scalar", oneof: "appIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppUserUpdatedTrigger>): AppUserUpdatedTrigger {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appIdentifier = { oneofKind: undefined };
        message.condition = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserUpdatedTrigger>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserUpdatedTrigger): AppUserUpdatedTrigger {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appIdentifier = {
                        oneofKind: "appId",
                        appId: reader.string()
                    };
                    break;
                case /* string app_id_cel */ 2:
                    message.appIdentifier = {
                        oneofKind: "appIdCel",
                        appIdCel: reader.string()
                    };
                    break;
                case /* string condition */ 3:
                    message.condition = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserUpdatedTrigger, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appIdentifier.oneofKind === "appId")
            writer.tag(1, WireType.LengthDelimited).string(message.appIdentifier.appId);
        /* string app_id_cel = 2; */
        if (message.appIdentifier.oneofKind === "appIdCel")
            writer.tag(2, WireType.LengthDelimited).string(message.appIdentifier.appIdCel);
        /* string condition = 3; */
        if (message.condition !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.condition);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AppUserUpdatedTrigger
 */
export const AppUserUpdatedTrigger = new AppUserUpdatedTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageBasedRevocationTrigger$Type extends MessageType<UsageBasedRevocationTrigger> {
    constructor() {
        super("c1.api.automations.v1.UsageBasedRevocationTrigger", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "enabled_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "unused_for_days", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "include_users_with_no_activity", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 100, name: "run_immediately", kind: "message", oneof: "coldStartSchedule", T: () => RunImmediately },
            { no: 101, name: "run_delayed", kind: "message", oneof: "coldStartSchedule", T: () => RunDelayed },
            { no: 7, name: "targeted_app_user_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserType", AppUserType, "APP_USER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "16" } } } },
            { no: 8, name: "targeted_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "16" } } } },
            { no: 9, name: "excluded_group_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "16" } } } },
            { no: 10, name: "excluded_user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<UsageBasedRevocationTrigger>): UsageBasedRevocationTrigger {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.unusedForDays = 0;
        message.includeUsersWithNoActivity = false;
        message.coldStartSchedule = { oneofKind: undefined };
        message.targetedAppUserTypes = [];
        message.targetedEntitlementRefs = [];
        message.excludedGroupRefs = [];
        message.excludedUserRefs = [];
        if (value !== undefined)
            reflectionMergePartial<UsageBasedRevocationTrigger>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsageBasedRevocationTrigger): UsageBasedRevocationTrigger {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* google.protobuf.Timestamp enabled_at */ 2:
                    message.enabledAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.enabledAt);
                    break;
                case /* uint32 unused_for_days */ 3:
                    message.unusedForDays = reader.uint32();
                    break;
                case /* bool include_users_with_no_activity */ 4:
                    message.includeUsersWithNoActivity = reader.bool();
                    break;
                case /* c1.api.automations.v1.RunImmediately run_immediately */ 100:
                    message.coldStartSchedule = {
                        oneofKind: "runImmediately",
                        runImmediately: RunImmediately.internalBinaryRead(reader, reader.uint32(), options, (message.coldStartSchedule as any).runImmediately)
                    };
                    break;
                case /* c1.api.automations.v1.RunDelayed run_delayed */ 101:
                    message.coldStartSchedule = {
                        oneofKind: "runDelayed",
                        runDelayed: RunDelayed.internalBinaryRead(reader, reader.uint32(), options, (message.coldStartSchedule as any).runDelayed)
                    };
                    break;
                case /* repeated c1.api.app.v1.AppUserType targeted_app_user_types */ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.targetedAppUserTypes.push(reader.int32());
                    else
                        message.targetedAppUserTypes.push(reader.int32());
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef targeted_entitlement_refs */ 8:
                    message.targetedEntitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef excluded_group_refs */ 9:
                    message.excludedGroupRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.user.v1.UserRef excluded_user_refs */ 10:
                    message.excludedUserRefs.push(UserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsageBasedRevocationTrigger, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* google.protobuf.Timestamp enabled_at = 2; */
        if (message.enabledAt)
            Timestamp.internalBinaryWrite(message.enabledAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* uint32 unused_for_days = 3; */
        if (message.unusedForDays !== 0)
            writer.tag(3, WireType.Varint).uint32(message.unusedForDays);
        /* bool include_users_with_no_activity = 4; */
        if (message.includeUsersWithNoActivity !== false)
            writer.tag(4, WireType.Varint).bool(message.includeUsersWithNoActivity);
        /* repeated c1.api.app.v1.AppUserType targeted_app_user_types = 7; */
        if (message.targetedAppUserTypes.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.targetedAppUserTypes.length; i++)
                writer.int32(message.targetedAppUserTypes[i]);
            writer.join();
        }
        /* repeated c1.api.app.v1.AppEntitlementRef targeted_entitlement_refs = 8; */
        for (let i = 0; i < message.targetedEntitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.targetedEntitlementRefs[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppEntitlementRef excluded_group_refs = 9; */
        for (let i = 0; i < message.excludedGroupRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.excludedGroupRefs[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.user.v1.UserRef excluded_user_refs = 10; */
        for (let i = 0; i < message.excludedUserRefs.length; i++)
            UserRef.internalBinaryWrite(message.excludedUserRefs[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.RunImmediately run_immediately = 100; */
        if (message.coldStartSchedule.oneofKind === "runImmediately")
            RunImmediately.internalBinaryWrite(message.coldStartSchedule.runImmediately, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.RunDelayed run_delayed = 101; */
        if (message.coldStartSchedule.oneofKind === "runDelayed")
            RunDelayed.internalBinaryWrite(message.coldStartSchedule.runDelayed, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.UsageBasedRevocationTrigger
 */
export const UsageBasedRevocationTrigger = new UsageBasedRevocationTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RunImmediately$Type extends MessageType<RunImmediately> {
    constructor() {
        super("c1.api.automations.v1.RunImmediately", []);
    }
    create(value?: PartialMessage<RunImmediately>): RunImmediately {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RunImmediately>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RunImmediately): RunImmediately {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RunImmediately, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.RunImmediately
 */
export const RunImmediately = new RunImmediately$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RunDelayed$Type extends MessageType<RunDelayed> {
    constructor() {
        super("c1.api.automations.v1.RunDelayed", [
            { no: 1, name: "cold_start_delay_days", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { gte: 1 } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<RunDelayed>): RunDelayed {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.coldStartDelayDays = 0;
        if (value !== undefined)
            reflectionMergePartial<RunDelayed>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RunDelayed): RunDelayed {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 cold_start_delay_days */ 1:
                    message.coldStartDelayDays = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RunDelayed, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 cold_start_delay_days = 1; */
        if (message.coldStartDelayDays !== 0)
            writer.tag(1, WireType.Varint).uint32(message.coldStartDelayDays);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.RunDelayed
 */
export const RunDelayed = new RunDelayed$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantTriggerFilter$Type extends MessageType<GrantTriggerFilter> {
    constructor() {
        super("c1.api.automations.v1.GrantTriggerFilter", [
            { no: 1, name: "grant_filter", kind: "message", T: () => GrantTriggerFilter_GrantFilter },
            { no: 3, name: "account_filter", kind: "message", T: () => GrantTriggerFilter_AccountFilter },
            { no: 4, name: "inclusion_list", kind: "message", oneof: "entitlementInclusion", T: () => EntitlementInclusionList },
            { no: 5, name: "inclusion_all", kind: "message", oneof: "entitlementInclusion", T: () => EntitlementInclusionAll },
            { no: 6, name: "inclusion_criteria", kind: "message", oneof: "entitlementInclusion", T: () => EntitlementInclusionCriteria },
            { no: 7, name: "inclusion_list_cel", kind: "message", oneof: "entitlementInclusion", T: () => EntitlementInclusionListCel }
        ]);
    }
    create(value?: PartialMessage<GrantTriggerFilter>): GrantTriggerFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entitlementInclusion = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<GrantTriggerFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantTriggerFilter): GrantTriggerFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.automations.v1.GrantTriggerFilter.GrantFilter grant_filter */ 1:
                    message.grantFilter = GrantTriggerFilter_GrantFilter.internalBinaryRead(reader, reader.uint32(), options, message.grantFilter);
                    break;
                case /* c1.api.automations.v1.GrantTriggerFilter.AccountFilter account_filter */ 3:
                    message.accountFilter = GrantTriggerFilter_AccountFilter.internalBinaryRead(reader, reader.uint32(), options, message.accountFilter);
                    break;
                case /* c1.api.automations.v1.EntitlementInclusionList inclusion_list */ 4:
                    message.entitlementInclusion = {
                        oneofKind: "inclusionList",
                        inclusionList: EntitlementInclusionList.internalBinaryRead(reader, reader.uint32(), options, (message.entitlementInclusion as any).inclusionList)
                    };
                    break;
                case /* c1.api.automations.v1.EntitlementInclusionAll inclusion_all */ 5:
                    message.entitlementInclusion = {
                        oneofKind: "inclusionAll",
                        inclusionAll: EntitlementInclusionAll.internalBinaryRead(reader, reader.uint32(), options, (message.entitlementInclusion as any).inclusionAll)
                    };
                    break;
                case /* c1.api.automations.v1.EntitlementInclusionCriteria inclusion_criteria */ 6:
                    message.entitlementInclusion = {
                        oneofKind: "inclusionCriteria",
                        inclusionCriteria: EntitlementInclusionCriteria.internalBinaryRead(reader, reader.uint32(), options, (message.entitlementInclusion as any).inclusionCriteria)
                    };
                    break;
                case /* c1.api.automations.v1.EntitlementInclusionListCel inclusion_list_cel */ 7:
                    message.entitlementInclusion = {
                        oneofKind: "inclusionListCel",
                        inclusionListCel: EntitlementInclusionListCel.internalBinaryRead(reader, reader.uint32(), options, (message.entitlementInclusion as any).inclusionListCel)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantTriggerFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.automations.v1.GrantTriggerFilter.GrantFilter grant_filter = 1; */
        if (message.grantFilter)
            GrantTriggerFilter_GrantFilter.internalBinaryWrite(message.grantFilter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.GrantTriggerFilter.AccountFilter account_filter = 3; */
        if (message.accountFilter)
            GrantTriggerFilter_AccountFilter.internalBinaryWrite(message.accountFilter, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.EntitlementInclusionList inclusion_list = 4; */
        if (message.entitlementInclusion.oneofKind === "inclusionList")
            EntitlementInclusionList.internalBinaryWrite(message.entitlementInclusion.inclusionList, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.EntitlementInclusionAll inclusion_all = 5; */
        if (message.entitlementInclusion.oneofKind === "inclusionAll")
            EntitlementInclusionAll.internalBinaryWrite(message.entitlementInclusion.inclusionAll, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.EntitlementInclusionCriteria inclusion_criteria = 6; */
        if (message.entitlementInclusion.oneofKind === "inclusionCriteria")
            EntitlementInclusionCriteria.internalBinaryWrite(message.entitlementInclusion.inclusionCriteria, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.EntitlementInclusionListCel inclusion_list_cel = 7; */
        if (message.entitlementInclusion.oneofKind === "inclusionListCel")
            EntitlementInclusionListCel.internalBinaryWrite(message.entitlementInclusion.inclusionListCel, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantTriggerFilter
 */
export const GrantTriggerFilter = new GrantTriggerFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantTriggerFilter_GrantFilter$Type extends MessageType<GrantTriggerFilter_GrantFilter> {
    constructor() {
        super("c1.api.automations.v1.GrantTriggerFilter.GrantFilter", [
            { no: 101, name: "grant_source_filter", kind: "enum", T: () => ["c1.api.automations.v1.GrantSourceFilter", GrantSourceFilter, "GRANT_SOURCE_FILTER_"] },
            { no: 102, name: "grant_filter_type", kind: "enum", T: () => ["c1.api.automations.v1.GrantFilterType", GrantFilterType, "GRANT_FILTER_TYPE_"] },
            { no: 103, name: "grant_justification_type", kind: "enum", T: () => ["c1.api.automations.v1.GrantJustificationType", GrantJustificationType, "GRANT_JUSTIFICATION_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<GrantTriggerFilter_GrantFilter>): GrantTriggerFilter_GrantFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.grantSourceFilter = 0;
        message.grantFilterType = 0;
        message.grantJustificationType = 0;
        if (value !== undefined)
            reflectionMergePartial<GrantTriggerFilter_GrantFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantTriggerFilter_GrantFilter): GrantTriggerFilter_GrantFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.automations.v1.GrantSourceFilter grant_source_filter */ 101:
                    message.grantSourceFilter = reader.int32();
                    break;
                case /* c1.api.automations.v1.GrantFilterType grant_filter_type */ 102:
                    message.grantFilterType = reader.int32();
                    break;
                case /* c1.api.automations.v1.GrantJustificationType grant_justification_type */ 103:
                    message.grantJustificationType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantTriggerFilter_GrantFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.automations.v1.GrantSourceFilter grant_source_filter = 101; */
        if (message.grantSourceFilter !== 0)
            writer.tag(101, WireType.Varint).int32(message.grantSourceFilter);
        /* c1.api.automations.v1.GrantFilterType grant_filter_type = 102; */
        if (message.grantFilterType !== 0)
            writer.tag(102, WireType.Varint).int32(message.grantFilterType);
        /* c1.api.automations.v1.GrantJustificationType grant_justification_type = 103; */
        if (message.grantJustificationType !== 0)
            writer.tag(103, WireType.Varint).int32(message.grantJustificationType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantTriggerFilter.GrantFilter
 */
export const GrantTriggerFilter_GrantFilter = new GrantTriggerFilter_GrantFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantTriggerFilter_EntitlementFilter$Type extends MessageType<GrantTriggerFilter_EntitlementFilter> {
    constructor() {
        super("c1.api.automations.v1.GrantTriggerFilter.EntitlementFilter", []);
    }
    create(value?: PartialMessage<GrantTriggerFilter_EntitlementFilter>): GrantTriggerFilter_EntitlementFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GrantTriggerFilter_EntitlementFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantTriggerFilter_EntitlementFilter): GrantTriggerFilter_EntitlementFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantTriggerFilter_EntitlementFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantTriggerFilter.EntitlementFilter
 */
export const GrantTriggerFilter_EntitlementFilter = new GrantTriggerFilter_EntitlementFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantTriggerFilter_AccountFilter$Type extends MessageType<GrantTriggerFilter_AccountFilter> {
    constructor() {
        super("c1.api.automations.v1.GrantTriggerFilter.AccountFilter", [
            { no: 301, name: "account_type", kind: "enum", T: () => ["c1.api.app.v1.AppUserType", AppUserType, "APP_USER_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<GrantTriggerFilter_AccountFilter>): GrantTriggerFilter_AccountFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountType = 0;
        if (value !== undefined)
            reflectionMergePartial<GrantTriggerFilter_AccountFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantTriggerFilter_AccountFilter): GrantTriggerFilter_AccountFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUserType account_type */ 301:
                    message.accountType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantTriggerFilter_AccountFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUserType account_type = 301; */
        if (message.accountType !== 0)
            writer.tag(301, WireType.Varint).int32(message.accountType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantTriggerFilter.AccountFilter
 */
export const GrantTriggerFilter_AccountFilter = new GrantTriggerFilter_AccountFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantFoundTrigger$Type extends MessageType<GrantFoundTrigger> {
    constructor() {
        super("c1.api.automations.v1.GrantFoundTrigger", [
            { no: 1, name: "grant_trigger_filter", kind: "message", T: () => GrantTriggerFilter }
        ]);
    }
    create(value?: PartialMessage<GrantFoundTrigger>): GrantFoundTrigger {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GrantFoundTrigger>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantFoundTrigger): GrantFoundTrigger {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.automations.v1.GrantTriggerFilter grant_trigger_filter */ 1:
                    message.grantTriggerFilter = GrantTriggerFilter.internalBinaryRead(reader, reader.uint32(), options, message.grantTriggerFilter);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantFoundTrigger, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.automations.v1.GrantTriggerFilter grant_trigger_filter = 1; */
        if (message.grantTriggerFilter)
            GrantTriggerFilter.internalBinaryWrite(message.grantTriggerFilter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantFoundTrigger
 */
export const GrantFoundTrigger = new GrantFoundTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantDeletedTrigger$Type extends MessageType<GrantDeletedTrigger> {
    constructor() {
        super("c1.api.automations.v1.GrantDeletedTrigger", [
            { no: 1, name: "grant_trigger_filter", kind: "message", T: () => GrantTriggerFilter }
        ]);
    }
    create(value?: PartialMessage<GrantDeletedTrigger>): GrantDeletedTrigger {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GrantDeletedTrigger>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantDeletedTrigger): GrantDeletedTrigger {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.automations.v1.GrantTriggerFilter grant_trigger_filter */ 1:
                    message.grantTriggerFilter = GrantTriggerFilter.internalBinaryRead(reader, reader.uint32(), options, message.grantTriggerFilter);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantDeletedTrigger, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.automations.v1.GrantTriggerFilter grant_trigger_filter = 1; */
        if (message.grantTriggerFilter)
            GrantTriggerFilter.internalBinaryWrite(message.grantTriggerFilter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantDeletedTrigger
 */
export const GrantDeletedTrigger = new GrantDeletedTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookAutomationTrigger$Type extends MessageType<WebhookAutomationTrigger> {
    constructor() {
        super("c1.api.automations.v1.WebhookAutomationTrigger", [
            { no: 1, name: "jwt", kind: "message", oneof: "authConfig", T: () => WebhookListenerAuthJWT },
            { no: 2, name: "hmac", kind: "message", oneof: "authConfig", T: () => WebhookListenerAuthHMAC },
            { no: 3, name: "listener_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<WebhookAutomationTrigger>): WebhookAutomationTrigger {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.authConfig = { oneofKind: undefined };
        message.listenerId = "";
        if (value !== undefined)
            reflectionMergePartial<WebhookAutomationTrigger>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookAutomationTrigger): WebhookAutomationTrigger {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.automations.v1.WebhookListenerAuthJWT jwt */ 1:
                    message.authConfig = {
                        oneofKind: "jwt",
                        jwt: WebhookListenerAuthJWT.internalBinaryRead(reader, reader.uint32(), options, (message.authConfig as any).jwt)
                    };
                    break;
                case /* c1.api.automations.v1.WebhookListenerAuthHMAC hmac */ 2:
                    message.authConfig = {
                        oneofKind: "hmac",
                        hmac: WebhookListenerAuthHMAC.internalBinaryRead(reader, reader.uint32(), options, (message.authConfig as any).hmac)
                    };
                    break;
                case /* string listener_id */ 3:
                    message.listenerId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookAutomationTrigger, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.automations.v1.WebhookListenerAuthJWT jwt = 1; */
        if (message.authConfig.oneofKind === "jwt")
            WebhookListenerAuthJWT.internalBinaryWrite(message.authConfig.jwt, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.WebhookListenerAuthHMAC hmac = 2; */
        if (message.authConfig.oneofKind === "hmac")
            WebhookListenerAuthHMAC.internalBinaryWrite(message.authConfig.hmac, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string listener_id = 3; */
        if (message.listenerId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.listenerId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.WebhookAutomationTrigger
 */
export const WebhookAutomationTrigger = new WebhookAutomationTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormTrigger$Type extends MessageType<FormTrigger> {
    constructor() {
        super("c1.api.automations.v1.FormTrigger", [
            { no: 1, name: "form", kind: "message", T: () => Form }
        ]);
    }
    create(value?: PartialMessage<FormTrigger>): FormTrigger {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FormTrigger>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FormTrigger): FormTrigger {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.form.v1.Form form */ 1:
                    message.form = Form.internalBinaryRead(reader, reader.uint32(), options, message.form);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FormTrigger, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.form.v1.Form form = 1; */
        if (message.form)
            Form.internalBinaryWrite(message.form, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.FormTrigger
 */
export const FormTrigger = new FormTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorRefs$Type extends MessageType<ConflictMonitorRefs> {
    constructor() {
        super("c1.api.automations.v1.ConflictMonitorRefs", [
            { no: 1, name: "conflict_monitor_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConflictMonitorRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } }, "pgdb.v1.options": { messageBehavior: "MESSAGE_BEHAVIOR_JSONB" } } }
        ], { "pgdb.v1.msg": { nestedOnly: true } });
    }
    create(value?: PartialMessage<ConflictMonitorRefs>): ConflictMonitorRefs {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.conflictMonitorRefs = [];
        if (value !== undefined)
            reflectionMergePartial<ConflictMonitorRefs>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConflictMonitorRefs): ConflictMonitorRefs {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessconflict.v1.ConflictMonitorRef conflict_monitor_refs */ 1:
                    message.conflictMonitorRefs.push(ConflictMonitorRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConflictMonitorRefs, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessconflict.v1.ConflictMonitorRef conflict_monitor_refs = 1; */
        for (let i = 0; i < message.conflictMonitorRefs.length; i++)
            ConflictMonitorRef.internalBinaryWrite(message.conflictMonitorRefs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ConflictMonitorRefs
 */
export const ConflictMonitorRefs = new ConflictMonitorRefs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessConflictTrigger$Type extends MessageType<AccessConflictTrigger> {
    constructor() {
        super("c1.api.automations.v1.AccessConflictTrigger", [
            { no: 100, name: "conflict_monitor_refs", kind: "message", oneof: "conflictMonitorSelector", T: () => ConflictMonitorRefs },
            { no: 101, name: "all_conflict_monitors", kind: "scalar", oneof: "conflictMonitorSelector", T: 8 /*ScalarType.BOOL*/ }
        ], { "pgdb.v1.msg": { nestedOnly: true } });
    }
    create(value?: PartialMessage<AccessConflictTrigger>): AccessConflictTrigger {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.conflictMonitorSelector = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AccessConflictTrigger>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessConflictTrigger): AccessConflictTrigger {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.automations.v1.ConflictMonitorRefs conflict_monitor_refs */ 100:
                    message.conflictMonitorSelector = {
                        oneofKind: "conflictMonitorRefs",
                        conflictMonitorRefs: ConflictMonitorRefs.internalBinaryRead(reader, reader.uint32(), options, (message.conflictMonitorSelector as any).conflictMonitorRefs)
                    };
                    break;
                case /* bool all_conflict_monitors */ 101:
                    message.conflictMonitorSelector = {
                        oneofKind: "allConflictMonitors",
                        allConflictMonitors: reader.bool()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessConflictTrigger, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.automations.v1.ConflictMonitorRefs conflict_monitor_refs = 100; */
        if (message.conflictMonitorSelector.oneofKind === "conflictMonitorRefs")
            ConflictMonitorRefs.internalBinaryWrite(message.conflictMonitorSelector.conflictMonitorRefs, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* bool all_conflict_monitors = 101; */
        if (message.conflictMonitorSelector.oneofKind === "allConflictMonitors")
            writer.tag(101, WireType.Varint).bool(message.conflictMonitorSelector.allConflictMonitors);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AccessConflictTrigger
 */
export const AccessConflictTrigger = new AccessConflictTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookListenerAuthJWT$Type extends MessageType<WebhookListenerAuthJWT> {
    constructor() {
        super("c1.api.automations.v1.WebhookListenerAuthJWT", [
            { no: 1, name: "jwks_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "2048", pattern: "^https://.*", uri: true } } } }
        ]);
    }
    create(value?: PartialMessage<WebhookListenerAuthJWT>): WebhookListenerAuthJWT {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.jwksUrl = "";
        if (value !== undefined)
            reflectionMergePartial<WebhookListenerAuthJWT>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookListenerAuthJWT): WebhookListenerAuthJWT {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string jwks_url */ 1:
                    message.jwksUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookListenerAuthJWT, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string jwks_url = 1; */
        if (message.jwksUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.jwksUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.WebhookListenerAuthJWT
 */
export const WebhookListenerAuthJWT = new WebhookListenerAuthJWT$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookListenerAuthHMAC$Type extends MessageType<WebhookListenerAuthHMAC> {
    constructor() {
        super("c1.api.automations.v1.WebhookListenerAuthHMAC", []);
    }
    create(value?: PartialMessage<WebhookListenerAuthHMAC>): WebhookListenerAuthHMAC {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WebhookListenerAuthHMAC>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookListenerAuthHMAC): WebhookListenerAuthHMAC {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookListenerAuthHMAC, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.WebhookListenerAuthHMAC
 */
export const WebhookListenerAuthHMAC = new WebhookListenerAuthHMAC$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleTrigger$Type extends MessageType<ScheduleTrigger> {
    constructor() {
        super("c1.api.automations.v1.ScheduleTrigger", [
            { no: 1, name: "start", kind: "message", T: () => Timestamp },
            { no: 2, name: "cron_spec", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } },
            { no: 3, name: "advanced", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "skip_if_true_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ScheduleTrigger>): ScheduleTrigger {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cronSpec = "";
        message.advanced = false;
        message.skipIfTrueCel = "";
        message.condition = "";
        message.timezone = "";
        if (value !== undefined)
            reflectionMergePartial<ScheduleTrigger>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ScheduleTrigger): ScheduleTrigger {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp start */ 1:
                    message.start = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.start);
                    break;
                case /* string cron_spec */ 2:
                    message.cronSpec = reader.string();
                    break;
                case /* bool advanced */ 3:
                    message.advanced = reader.bool();
                    break;
                case /* string skip_if_true_cel = 4 [deprecated = true] */ 4:
                    message.skipIfTrueCel = reader.string();
                    break;
                case /* string condition */ 5:
                    message.condition = reader.string();
                    break;
                case /* string timezone */ 6:
                    message.timezone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ScheduleTrigger, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp start = 1; */
        if (message.start)
            Timestamp.internalBinaryWrite(message.start, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cron_spec = 2; */
        if (message.cronSpec !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cronSpec);
        /* bool advanced = 3; */
        if (message.advanced !== false)
            writer.tag(3, WireType.Varint).bool(message.advanced);
        /* string skip_if_true_cel = 4 [deprecated = true]; */
        if (message.skipIfTrueCel !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.skipIfTrueCel);
        /* string condition = 5; */
        if (message.condition !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.condition);
        /* string timezone = 6; */
        if (message.timezone !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.timezone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ScheduleTrigger
 */
export const ScheduleTrigger = new ScheduleTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleTriggerAppUser$Type extends MessageType<ScheduleTriggerAppUser> {
    constructor() {
        super("c1.api.automations.v1.ScheduleTriggerAppUser", [
            { no: 1, name: "start", kind: "message", T: () => Timestamp },
            { no: 2, name: "cron_spec", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } },
            { no: 3, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 5, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ScheduleTriggerAppUser>): ScheduleTriggerAppUser {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cronSpec = "";
        message.condition = "";
        message.appId = "";
        message.timezone = "";
        if (value !== undefined)
            reflectionMergePartial<ScheduleTriggerAppUser>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ScheduleTriggerAppUser): ScheduleTriggerAppUser {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp start */ 1:
                    message.start = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.start);
                    break;
                case /* string cron_spec */ 2:
                    message.cronSpec = reader.string();
                    break;
                case /* string condition */ 3:
                    message.condition = reader.string();
                    break;
                case /* string app_id */ 4:
                    message.appId = reader.string();
                    break;
                case /* string timezone */ 5:
                    message.timezone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ScheduleTriggerAppUser, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp start = 1; */
        if (message.start)
            Timestamp.internalBinaryWrite(message.start, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cron_spec = 2; */
        if (message.cronSpec !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cronSpec);
        /* string condition = 3; */
        if (message.condition !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.condition);
        /* string app_id = 4; */
        if (message.appId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appId);
        /* string timezone = 5; */
        if (message.timezone !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.timezone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ScheduleTriggerAppUser
 */
export const ScheduleTriggerAppUser = new ScheduleTriggerAppUser$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationTemplateVersion$Type extends MessageType<AutomationTemplateVersion> {
    constructor() {
        super("c1.api.automations.v1.AutomationTemplateVersion", [
            { no: 1, name: "automation_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "version", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "automation_steps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationStep },
            { no: 4, name: "triggers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationTrigger },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<AutomationTemplateVersion>): AutomationTemplateVersion {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.automationTemplateId = "";
        message.version = 0;
        message.automationSteps = [];
        message.triggers = [];
        if (value !== undefined)
            reflectionMergePartial<AutomationTemplateVersion>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AutomationTemplateVersion): AutomationTemplateVersion {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string automation_template_id */ 1:
                    message.automationTemplateId = reader.string();
                    break;
                case /* int64 version */ 2:
                    message.version = reader.int64().toNumber();
                    break;
                case /* repeated c1.api.automations.v1.AutomationStep automation_steps */ 3:
                    message.automationSteps.push(AutomationStep.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.automations.v1.AutomationTrigger triggers */ 4:
                    message.triggers.push(AutomationTrigger.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 6:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 7:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AutomationTemplateVersion, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string automation_template_id = 1; */
        if (message.automationTemplateId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.automationTemplateId);
        /* int64 version = 2; */
        if (message.version !== 0)
            writer.tag(2, WireType.Varint).int64(message.version);
        /* repeated c1.api.automations.v1.AutomationStep automation_steps = 3; */
        for (let i = 0; i < message.automationSteps.length; i++)
            AutomationStep.internalBinaryWrite(message.automationSteps[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.automations.v1.AutomationTrigger triggers = 4; */
        for (let i = 0; i < message.triggers.length; i++)
            AutomationTrigger.internalBinaryWrite(message.triggers[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 6; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 7; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationTemplateVersion
 */
export const AutomationTemplateVersion = new AutomationTemplateVersion$Type();
/**
 * @generated ServiceType for protobuf service c1.api.automations.v1.AutomationSearchService
 */
export const AutomationSearchService = new ServiceType("c1.api.automations.v1.AutomationSearchService", [
    { name: "SearchAutomations", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/automations", group: "Automations" }] } }, I: SearchAutomationsRequest, O: SearchAutomationsResponse },
    { name: "SearchAutomationTemplateVersions", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/automation_versions", group: "Automations" }] } }, I: SearchAutomationTemplateVersionsRequest, O: SearchAutomationTemplateVersionsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.automations.v1.AutomationService
 */
export const AutomationService = new ServiceType("c1.api.automations.v1.AutomationService", [
    { name: "GetAutomation", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/automations/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Automation", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "Automations" }] } }, I: GetAutomationRequest, O: GetAutomationResponse },
    { name: "CreateAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/automations", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Automation" }], group: "Automations" }] } }, I: CreateAutomationRequest, O: CreateAutomationResponse },
    { name: "ListAutomations", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/automations", group: "Automations" }] } }, I: ListAutomationsRequest, O: ListAutomationsResponse },
    { name: "DeleteAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/automations/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Automation" }], group: "Automations" }] } }, I: DeleteAutomationRequest, O: DeleteAutomationResponse },
    { name: "UpdateAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/automations/{automation.id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Automation" }], group: "Automations" }] } }, I: UpdateAutomationRequest, O: UpdateAutomationResponse },
    { name: "ExecuteAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/automations/{id}/execute", group: "Automations" }] } }, I: ExecuteAutomationRequest, O: ExecuteAutomationResponse }
]);
